/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-appearance-applicationcache-boxshadow-boxsizing-cssanimations-csscalc-cssgradients-csstransforms-csstransforms3d-csstransitions-cssvhunit-fontface-fullscreen-geolocation-hashchange-ie8compat-json-localstorage-postmessage-requestanimationframe-touchevents-video-videoautoplay-setclasses !*/
!function(A,e,t){function n(A,e){return typeof A===e}function o(){var A,e,t,o,r,i,a;for(var s in y)if(y.hasOwnProperty(s)){if(A=[],e=y[s],e.name&&(A.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(t=0;t<e.options.aliases.length;t++)A.push(e.options.aliases[t].toLowerCase());for(o=n(e.fn,"function")?e.fn():e.fn,r=0;r<A.length;r++)i=A[r],a=i.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),T.push((o?"":"no-")+a.join("-"))}}function r(A){var e=E.className,t=Modernizr._config.classPrefix||"";if(x&&(e=e.baseVal),Modernizr._config.enableJSClass){var n=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");e=e.replace(n,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e+=" "+t+A.join(" "+t),x?E.className.baseVal=e:E.className=e)}function i(){return"function"!=typeof e.createElement?e.createElement(arguments[0]):x?e.createElementNS.call(e,"http://www.w3.org/2000/svg",arguments[0]):e.createElement.apply(e,arguments)}function a(e,t,n){var o;if("getComputedStyle"in A){o=getComputedStyle.call(A,e,t);var r=A.console;if(null!==o)n&&(o=o.getPropertyValue(n));else if(r){var i=r.error?"error":"log";r[i].call(r,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&e.currentStyle&&e.currentStyle[n];return o}function s(A){return A.replace(/([a-z])-([a-z])/g,function(A,e,t){return e+t.toUpperCase()}).replace(/^-/,"")}function l(A,e){if("object"==typeof A)for(var t in A)b(A,t)&&l(t,A[t]);else{A=A.toLowerCase();var n=A.split("."),o=Modernizr[n[0]];if(2==n.length&&(o=o[n[1]]),"undefined"!=typeof o)return Modernizr;e="function"==typeof e?e():e,1==n.length?Modernizr[n[0]]=e:(!Modernizr[n[0]]||Modernizr[n[0]]instanceof Boolean||(Modernizr[n[0]]=new Boolean(Modernizr[n[0]])),Modernizr[n[0]][n[1]]=e),r([(e&&0!=e?"":"no-")+n.join("-")]),Modernizr._trigger(A,e)}return Modernizr}function c(){var A=e.body;return A||(A=i(x?"svg":"body"),A.fake=!0),A}function d(A,t,n,o){var r,a,s,l,d="modernizr",u=i("div"),f=c();if(parseInt(n,10))for(;n--;)s=i("div"),s.id=o?o[n]:d+(n+1),u.appendChild(s);return r=i("style"),r.type="text/css",r.id="s"+d,(f.fake?f:u).appendChild(r),f.appendChild(u),r.styleSheet?r.styleSheet.cssText=A:r.appendChild(e.createTextNode(A)),u.id=d,f.fake&&(f.style.background="",f.style.overflow="hidden",l=E.style.overflow,E.style.overflow="hidden",E.appendChild(f)),a=t(u,A),f.fake?(f.parentNode.removeChild(f),E.style.overflow=l,E.offsetHeight):u.parentNode.removeChild(u),!!a}function u(A,e){return!!~(""+A).indexOf(e)}function f(A,e){return function(){return A.apply(e,arguments)}}function p(A,e,t){var o;for(var r in A)if(A[r]in e)return t===!1?A[r]:(o=e[A[r]],n(o,"function")?f(o,t||e):o);return!1}function h(A){return A.replace(/([A-Z])/g,function(A,e){return"-"+e.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(e,n){var o=e.length;if("CSS"in A&&"supports"in A.CSS){for(;o--;)if(A.CSS.supports(h(e[o]),n))return!0;return!1}if("CSSSupportsRule"in A){for(var r=[];o--;)r.push("("+h(e[o])+":"+n+")");return r=r.join(" or "),d("@supports ("+r+") { #modernizr { position: absolute; } }",function(A){return"absolute"==a(A,null,"position")})}return t}function g(A,e,o,r){function a(){c&&(delete U.style,delete U.modElem)}if(r=n(r,"undefined")?!1:r,!n(o,"undefined")){var l=m(A,o);if(!n(l,"undefined"))return l}for(var c,d,f,p,h,g=["modernizr","tspan","samp"];!U.style&&g.length;)c=!0,U.modElem=i(g.shift()),U.style=U.modElem.style;for(f=A.length,d=0;f>d;d++)if(p=A[d],h=U.style[p],u(p,"-")&&(p=s(p)),U.style[p]!==t){if(r||n(o,"undefined"))return a(),"pfx"==e?p:!0;try{U.style[p]=o}catch(v){}if(U.style[p]!=h)return a(),"pfx"==e?p:!0}return a(),!1}function v(A,e,t,o,r){var i=A.charAt(0).toUpperCase()+A.slice(1),a=(A+" "+M.join(i+" ")+i).split(" ");return n(e,"string")||n(e,"undefined")?g(a,e,o,r):(a=(A+" "+P.join(i+" ")+i).split(" "),p(a,e,t))}function w(A,e,n){return v(A,t,t,e,n)}var T=[],y=[],R={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(A,e){var t=this;setTimeout(function(){e(t[A])},0)},addTest:function(A,e,t){y.push({name:A,fn:e,options:t})},addAsyncTest:function(A){y.push({name:null,fn:A})}},Modernizr=function(){};Modernizr.prototype=R,Modernizr=new Modernizr,Modernizr.addTest("applicationcache","applicationCache"in A),Modernizr.addTest("geolocation","geolocation"in navigator),Modernizr.addTest("ie8compat",!A.addEventListener&&!!e.documentMode&&7===e.documentMode),Modernizr.addTest("json","JSON"in A&&"parse"in JSON&&"stringify"in JSON),Modernizr.addTest("postmessage","postMessage"in A),Modernizr.addTest("localstorage",function(){var A="modernizr";try{return localStorage.setItem(A,A),localStorage.removeItem(A),!0}catch(e){return!1}});var E=e.documentElement,x="svg"===E.nodeName.toLowerCase(),B=R._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];R._prefixes=B,Modernizr.addTest("video",function(){var A=i("video"),e=!1;try{e=!!A.canPlayType,e&&(e=new Boolean(e),e.ogg=A.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),e.h264=A.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),e.webm=A.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),e.vp9=A.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),e.hls=A.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(t){}return e}),Modernizr.addTest("csscalc",function(){var A="width:",e="calc(10px);",t=i("a");return t.style.cssText=A+B.join(e+A),!!t.style.length}),Modernizr.addTest("cssgradients",function(){for(var A,e="background-image:",t="gradient(linear,left top,right bottom,from(#9f9),to(white));",n="",o=0,r=B.length-1;r>o;o++)A=0===o?"to ":"",n+=e+B[o]+"linear-gradient("+A+"left top, #9f9, white);";Modernizr._config.usePrefixes&&(n+=e+"-webkit-"+t);var a=i("a"),s=a.style;return s.cssText=n,(""+s.backgroundImage).indexOf("gradient")>-1});var F=function(){function A(A,e){var o;return A?(e&&"string"!=typeof e||(e=i(e||"div")),A="on"+A,o=A in e,!o&&n&&(e.setAttribute||(e=i("div")),e.setAttribute(A,""),o="function"==typeof e[A],e[A]!==t&&(e[A]=t),e.removeAttribute(A)),o):!1}var n=!("onblur"in e.documentElement);return A}();R.hasEvent=F,Modernizr.addTest("hashchange",function(){return F("hashchange",A)===!1?!1:e.documentMode===t||e.documentMode>7});var G="CSS"in A&&"supports"in A.CSS,C="supportsCSS"in A;Modernizr.addTest("supports",G||C);var b;!function(){var A={}.hasOwnProperty;b=n(A,"undefined")||n(A.call,"undefined")?function(A,e){return e in A&&n(A.constructor.prototype[e],"undefined")}:function(e,t){return A.call(e,t)}}(),R._l={},R.on=function(A,e){this._l[A]||(this._l[A]=[]),this._l[A].push(e),Modernizr.hasOwnProperty(A)&&setTimeout(function(){Modernizr._trigger(A,Modernizr[A])},0)},R._trigger=function(A,e){if(this._l[A]){var t=this._l[A];setTimeout(function(){var A,n;for(A=0;A<t.length;A++)(n=t[A])(e)},0),delete this._l[A]}},Modernizr._q.push(function(){R.addTest=l}),Modernizr.addAsyncTest(function(){function A(i){o++,clearTimeout(e);var a=i&&"playing"===i.type||0!==r.currentTime;return!a&&n>o?void(e=setTimeout(A,t)):(r.removeEventListener("playing",A,!1),l("videoautoplay",a),void(r.parentNode&&r.parentNode.removeChild(r)))}var e,t=200,n=5,o=0,r=i("video"),a=r.style;if(!(Modernizr.video&&"autoplay"in r))return void l("videoautoplay",!1);a.position="absolute",a.height=0,a.width=0;try{if(Modernizr.video.ogg)r.src="data:video/ogg;base64,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";else{if(!Modernizr.video.h264)return void l("videoautoplay",!1);r.src="data:video/mp4;base64,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"}}catch(s){return void l("videoautoplay",!1)}r.setAttribute("autoplay",""),r.style.cssText="display:none",E.appendChild(r),setTimeout(function(){r.addEventListener("playing",A,!1),e=setTimeout(A,t)},0)});var Q=R.testStyles=d;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in A||A.DocumentTouch&&e instanceof DocumentTouch)t=!0;else{var n=["@media (",B.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");Q(n,function(A){t=9===A.offsetTop})}return t});var S=function(){var A=navigator.userAgent,e=A.match(/w(eb)?osbrowser/gi),t=A.match(/windows phone/gi)&&A.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9;return e||t}();S?Modernizr.addTest("fontface",!1):Q('@font-face {font-family:"font";src:url("https://")}',function(A,t){var n=e.getElementById("smodernizr"),o=n.sheet||n.styleSheet,r=o?o.cssRules&&o.cssRules[0]?o.cssRules[0].cssText:o.cssText||"":"",i=/src/i.test(r)&&0===r.indexOf(t.split(" ")[0]);Modernizr.addTest("fontface",i)}),Q("#modernizr { height: 50vh; }",function(e){var t=parseInt(A.innerHeight/2,10),n=parseInt(a(e,null,"height"),10);Modernizr.addTest("cssvhunit",n==t)});var Z="Moz O ms Webkit",M=R._config.usePrefixes?Z.split(" "):[];R._cssomPrefixes=M;var Y=function(e){var n,o=B.length,r=A.CSSRule;if("undefined"==typeof r)return t;if(!e)return!1;if(e=e.replace(/^@/,""),n=e.replace(/-/g,"_").toUpperCase()+"_RULE",n in r)return"@"+e;for(var i=0;o>i;i++){var a=B[i],s=a.toUpperCase()+"_"+n;if(s in r)return"@-"+a.toLowerCase()+"-"+e}return!1};R.atRule=Y;var P=R._config.usePrefixes?Z.toLowerCase().split(" "):[];R._domPrefixes=P;var I={elem:i("modernizr")};Modernizr._q.push(function(){delete I.elem});var U={style:I.elem.style};Modernizr._q.unshift(function(){delete U.style}),R.testAllProps=v;var V=R.prefixed=function(A,e,t){return 0===A.indexOf("@")?Y(A):(-1!=A.indexOf("-")&&(A=s(A)),e?v(A,e,t):v(A,"pfx"))};Modernizr.addTest("fullscreen",!(!V("exitFullscreen",e,!1)&&!V("cancelFullScreen",e,!1))),Modernizr.addTest("requestanimationframe",!!V("requestAnimationFrame",A),{aliases:["raf"]}),R.testAllProps=w,Modernizr.addTest("appearance",w("appearance")),Modernizr.addTest("boxshadow",w("boxShadow","1px 1px",!0)),Modernizr.addTest("boxsizing",w("boxSizing","border-box",!0)&&(e.documentMode===t||e.documentMode>7)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&w("transform","scale(1)",!0)}),Modernizr.addTest("csstransforms3d",function(){var A=!!w("perspective","1px",!0),e=Modernizr._config.usePrefixes;if(A&&(!e||"webkitPerspective"in E.style)){var t,n="#modernizr{width:0;height:0}";Modernizr.supports?t="@supports (perspective: 1px)":(t="@media (transform-3d)",e&&(t+=",(-webkit-transform-3d)")),t+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",Q(n+t,function(e){A=7===e.offsetWidth&&18===e.offsetHeight})}return A}),Modernizr.addTest("csstransitions",w("transition","all",!0)),Modernizr.addTest("cssanimations",w("animationName","a",!0)),o(),r(T),delete R.addTest,delete R.addAsyncTest;for(var N=0;N<Modernizr._q.length;N++)Modernizr._q[N]();A.Modernizr=Modernizr}(window,document);




/**
 *	Tracks JS errors and sends a report to the server.
 */
window.onerror	=	function (message, source, lineno, colno, error) {
	
	if (typeof message === 'undefined')	var message	=	'';
	if (typeof source === 'undefined')	var source	=	'';
	if (typeof lineno === 'undefined')	var lineno	=	0;
	if (typeof colno === 'undefined')	var colno	=	0;
	
	var stack	=	'';
	
	if (typeof error === 'object' && typeof error.stack === 'string')	stack	=	error.stack;
	
	$.ajax({
		url			:	'/library/php/capture-js-error.php',
		type		:	'post',
		dataType	:	'json',
		data		:	{
			je_message	:	message,
			je_source	:	source,
			je_lineno	:	lineno,
			je_colno	:	colno,
			je_url		:	window.location.href,
			je_stack	:	stack
		}
	});
	
};









//polyfill for old $.browser api
jQuery.uaMatch = function( ua ) {
	ua = ua.toLowerCase();

	var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
		/(webkit)[ \/]([\w.]+)/.exec( ua ) ||
		/(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
		/(msie) ([\w.]+)/.exec( ua ) ||
		ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
		[];

	return {
		browser: match[ 1 ] || "",
		version: match[ 2 ] || "0"
	};
};

// Don't clobber any existing jQuery.browser in case it's different
if ( !jQuery.browser ) {
	matched = jQuery.uaMatch( navigator.userAgent );
	browser = {};

	if ( matched.browser ) {
		browser[ matched.browser ] = true;
		browser.version = matched.version;
	}

	// Chrome is Webkit, but Webkit is also Safari.
	if ( browser.chrome ) {
		browser.webkit = true;
	} else if ( browser.webkit ) {
		browser.safari = true;
	}

	jQuery.browser = browser;
}





//add global easing method
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend( jQuery.easing,
{
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	}
});




(function($) {

var types = ['DOMMouseScroll', 'mousewheel'];

if ($.event.fixHooks) {
    for ( var i=types.length; i; ) {
        $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
    }
}

$.event.special.mousewheel = {
    setup: function() {
        if ( this.addEventListener ) {
            for ( var i=types.length; i; ) {
                this.addEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = handler;
        }
    },
    
    teardown: function() {
        if ( this.removeEventListener ) {
            for ( var i=types.length; i; ) {
                this.removeEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = null;
        }
    }
};

$.fn.extend({
    mousewheel: function(fn) {
        return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },
    
    unmousewheel: function(fn) {
        return this.unbind("mousewheel", fn);
    }
});


function handler(event) {
    var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";
    
    // Old school scrollwheel delta
    if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
    if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }
    
    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;
    
    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
        deltaY = 0;
        deltaX = -1*delta;
    }
    
    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }
    
    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);
    
    return ($.event.dispatch || $.event.handle).apply(this, args);
}

})(jQuery);









/*Request Animation Polyfill*/
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = 
          window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
    }
 
    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
 
    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());









//http://osvaldas.info/detecting-css-animation-transition-end-with-javascript

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

;( function( $, window, document, undefined )
{
	var s = document.body || document.documentElement, s = s.style, prefixAnimation = '', prefixTransition = '';

	if( s.WebkitAnimation == '' )	prefixAnimation	 = '-webkit-';
	if( s.MozAnimation == '' )		prefixAnimation	 = '-moz-';
	if( s.OAnimation == '' )		prefixAnimation	 = '-o-';

	if( s.WebkitTransition == '' )	prefixTransition = '-webkit-';
	if( s.MozTransition == '' )		prefixTransition = '-moz-';
	if( s.OTransition == '' )		prefixTransition = '-o-';

	$.fn.extend(
	{
		onCSSAnimationEnd: function( callback )
		{
			var $this = $( this ).eq( 0 );
			$this.one( 'webkitAnimationEnd mozAnimationEnd oAnimationEnd oanimationend animationend', callback );
			if( ( prefixAnimation == '' && !( 'animation' in s ) ) || $this.css( prefixAnimation + 'animation-duration' ) == '0s' ) callback();
			return this;
		},
		onCSSTransitionEnd: function( callback )
		{
			var $this = $( this ).eq( 0 );
			$this.one( 'webkitTransitionEnd mozTransitionEnd oTransitionEnd otransitionend transitionend', callback );
			if( ( prefixTransition == '' && !( 'transition' in s ) ) || $this.css( prefixTransition + 'transition-duration' ) == '0s' ) callback();
			return this;
		}
	});
})( jQuery, window, document );









/*!
 * Copyright (C) 2012-2018, 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * WendoverFun.com New Layout JS - 2014-05-14
 *
 *	Changes:
 *				2014-05-14	Commented-out random-cap code.
 *				2014-11-05	Fixed issue with .nav-grad using image backup for newer Chrome versions.
 *				2014-12-08	Fixed issue with main nav links when resizing browser from .ui-mobile to larger ui.
 *				2015-05-26	Added "unsecure browser" code.
 *				2015-05-27	Fixed issue with "unsecure browser" code displaying on first page load for supported browsers.
 *							Added GA tracking to "Next Step" button in header reservations widget.
 *							Added GA tracking to "unsecure browser" warning being displayed.
 *							Updated "unsecure browser" API request timeout to be 15 seconds (up from 10).
 *				2015-05-28	Updated "unsecure browser" message for hotel reservations to include a "Continue Anyway" button in case of false positive. This includes GA tracking for clicks on this new button
 *							Fixed "Continue Anyway" button for hotel reservation "unsecure browser" message.
 *				2015-11-03	Added code to attempt to auto-login users when the OPC_RM (remember me) cookie is set.
 *				2016-01-12	Fixed "unsecure browser" code so it works better on subsequent page-views.
 *				2016-05-03	Added code to track JS errors.
 *				2016-11-29	Added code for Confirmation Dialogs and attached them to links that lead to other websites
 *				2017-02-03	Added "javascript:" links to the whitelist for Confirmation Dialogs in the 2016-011-29 code update.
 *				2017-04-07	Fixed bug with the mobile UI which sent users to a 404 error when trying to book a hotel room.
 *				2018-07-05	Fixed bug with the calendar slider for booking a room not being wide enough.
 *				2019-03-05	Fixed bug with the hotel booking overlay being closed when interacting with a datepicker.
 *				2024-06-20  Move GOLF-SIGNUP-SUCCESS callback to golf-signup.js.
 */
(function ($) {
	
	var $artwork		= $("#artwork"),
		$artContent		= $artwork.find(".content"),
		$artCaption		= $artwork.find(".caption"),
		$artDots		= $artwork.find(".thumb-dots").find(".dot"),
		$artDotOver		= $artwork.find(".thumb-dots").find(".dot-overlay"),
		currSlide		= ($artContent.filter(".active").length > 0)
							? parseInt($artContent.filter(".active").data("index"), 10)
							: 0,
		showTransDur	= 925,
		showFadeDur		= 750,
		capDur			= 425,
		capWait			= 500,
		showTimer		= null,
		showStarted		= false,
		resizeTimer		= null,
		artResizeTimer	= null,
		dotOverlayTimer	= null,
		showHoverTimer	= null,
		lastSlideStart	= 0,
		windowIsActive	=	true,
		//captionPos		= [
		//	["cap-right", "cap-left"],	//horizontal
		//	["cap-top", "cap-bottom"]	//vertical
		//],
		resizeVideoArtwork	=	function () {
			
			//resize videos if necessary
			$.each($artContent.filter('.video'), function () {
				
				var $video	=	$(this);
				
				if (typeof $video.data('videojs') !== 'undefined') {
					
					var videoDims	=	calcVideoDims($video.data());
					
					/*$video
						.data('videojs')
							.dimension('width', videoDims.width);
					
					$video
						.data('videojs')
							.dimension('height', videoDims.height);*/
					
					$video
						.find('.video-js').css({
							top		:	videoDims.top,
							left	:	videoDims.left,
							width	:	videoDims.width,
							height	:	videoDims.height
						});
					
				}
				
			});
			
		},
		calcVideoDims	=	function (videoData) {
			
			var containerHeight	=	$artwork.outerHeight(),
				newWidth		=	$artwork.outerWidth(),
				newHeight		=	(videoData.sizing === 'contain')
										?	containerHeight
										:	newWidth * videoData.initHeight / videoData.initWidth,
				newTop			=	(videoData.sizing === 'contain')
										?	0
										:	(newHeight - containerHeight) * -1 * videoData.focalY / 100,
				newLeft			=	0;
			
			if (newHeight + newTop < containerHeight) {
				
				newTop		=	0;
				newHeight	=	containerHeight;
				newWidth	=	videoData.initWidth * newHeight / videoData.initHeight;
				newLeft		=	(newWidth - $artwork.outerWidth()) * -1 * videoData.focalX / 100;
				
			}
			
			return {
				width	:	newWidth,
				height	:	newHeight,
				left	:	newLeft,
				top		:	newTop
			};
			
		},
		initVideo		=	function (index, ele) {
			
			var $video	=	$(ele);
			
			if ($video.hasClass('initialized') === false) {
				
				//initialize a video slide
				var	videoData	=	$video.data('video-data')/*,
					maxDim		=	screen.width,
					poster		=	$.reduce(videoData.posters, function (carry, item) {
						
						if (typeof carry.width === 'undefined')	return item;

						var itemDiff	=	Math.abs(maxDim - item.width),
							carryDiff	=	Math.abs(maxDim - carry.width);
						
						if (itemDiff < carryDiff)	return item;
						
						return carry;
						
					}, {}),
					stream		=	$.grep(videoData.streams, function (streamObj) {
						
						return streamObj.quality === 'hls';
						
					})[0]*/;
				
				//if (stream.quality === 'hls')	stream.type	=	'application/x-mpegURL';
				
				var videoDims		=	calcVideoDims($video.data())/*,
					$videoContainer	=	$('<video class="video-js" id="artwork-video-' + $video.data('video-id') + '-' + $video.data('index') + '" preload="auto" poster="' + poster.src + '" width="' + videoDims.width + 'px" height="' + videoDims.height + 'px" style="top:' + videoDims.top + 'px;left:' + videoDims.left + 'px" webkit-playsinline playsinline><source src="' + stream.src + '" type="' + stream.type + '" /></video>')*/;
				
				$video
					.data('playing', false)
					.find('video, .video-js')
						.css({
							width	:	videoDims.width,
							height	:	videoDims.height,
							top		:	videoDims.top,
							left	:	videoDims.left
						})
					.end();//.append($videoContainer);
				
				$video.data('videojs', videojs('artwork-video-' + $video.data('video-id') + '-' + $video.data('index'), {
					flash	:	{
						swf		:	'/library/swf/video-js.swf',
						params	:	{
							wmode	:	'transparent',
							bgcolor	:	'transparent'
						}
					}
				}));
				
				//add play button for touch devices
				//if (Modernizr.touchevents || parseInt($video.data('autoplay'), 10) === 0) {
					
					$artCaption
						.eq(index)
							.append(
								$('<a class="video-btn play-btn"></a>')
									.append('<svg width="24" height="24" viewBox="0 0 24 24" id="ic_play_circle_outline_24px" x="24" y="144"><path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>')
									.on('click', function (event) {
										
										event.preventDefault();
										event.stopPropagation();
										
										$(this)
											.addClass('hide')
											.siblings('.pause-btn')
												.removeClass('hide');
										
										$video
											.data('playing', true);
										
										if ($artContent.eq(currSlide).hasClass('video') && typeof $artContent.eq(currSlide).data('videojs') !== 'undefined') {
										
											$video
												.data('videojs')
													.play();
										
										}
											
									})
							)
							.append(
									$('<a class="video-btn pause-btn hide"></a>')
										.append('<svg width="24" height="24" viewBox="0 0 24 24" id="ic_pause_circle_filled_24px" x="144" y="72"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/></svg>')
										.on('click', function (event) {
											
											event.preventDefault();
											event.stopPropagation();
											
											$(this)
												.addClass('hide')
												.siblings('.play-btn')
													.removeClass('hide');
											
											$video
												.data('playing', false);
											
											if ($artContent.eq(currSlide).hasClass('video') && typeof $artContent.eq(currSlide).data('videojs') !== 'undefined') {
											
												$video
													.data('videojs')
														.pause();
											
											}
												
										})
								);
					
				//}
				
				//add volume button (mute/unmute)
				if (parseInt(videoData.silent, 10) === 0) {
					
					if ($artCaption.eq(index).find('.volume-btn').length === 0) {
						
						$artCaption
							.eq(index)
								.append(
									$('<a class="volume-btn dock bottom-left" href="#">SOUND</a>')
										.on('click', function (event) {
											
											event.preventDefault();
											event.stopPropagation();
											
											if ($(this).hasClass('audio-on')) {
												
												$video
													.data('videojs')
														.muted(true)
														.volume(0);
												
												$(this)
													.removeClass('audio-on');
												
											} else {
												
												$video
													.data('videojs')
														.muted(false)
														.volume(1);
												
												$(this)
													.addClass('audio-on');
												
											}
											
										})
								);
						
					} else {
						
						$artCaption
							.eq(index)
								.find('.volume-btn')
									.on('click', function (event) {
										
										event.preventDefault();
										event.stopPropagation();
										
										if ($(this).hasClass('audio-on')) {
											
											$video
												.data('videojs')
													.muted(true)
													.volume(0);
											
											$(this)
												.removeClass('audio-on');
											
										} else {
											
											$video
												.data('videojs')
													.muted(false)
													.volume(1);
											
											$(this)
												.addClass('audio-on');
											
										}
										
									})
						
					}
					
				}
				
				//add reply button
				/*$video.append(
					$('<button class="video-btn replay-btn hide" />').append('<span class="label" data-label="Replay" />').on('click', function () {
						
						$video.data('videojs').currentTime(0).play();
						
					})
				);*/
				
				$video.data('videojs').on('ended', function () {
					
					pepTracking.event('Video', 'Ended', $video.data('video-id').toString());
					
					if ($artContent.length > 1) {
						
						runSlideshow(currSlide + 1);
						
					} else {
						
						//this video is the only slide, show a "reply" button
						//$video.find('.replay-btn').removeClass('hide');
						
						//replay
						$video.data('videojs').currentTime(0).play();
						
					}
					
				}).on('playing', function () {
					
					$video
						.data('playing', true);
					
					$artCaption
						.eq(index)
							.find('.play-btn, .replay-btn')
								.addClass('hide')
							.end()
							.find('.pause-btn')
								.removeClass('hide');
					
					clearTimeout(showTimer);
					
				}).one('playing', function () {
					
					pepTracking.event('Video', 'Started', $video.data('video-id').toString());
					
				}).on('error', function () {
					
					pepTracking.event('Video', 'Error', $video.data('video-id').toString() + ': (' + $video.data('videojs').error().code + ') ' + $video.data('videojs').error().message);
					
				});
				
				if ($artDots.filter('[data-index=' + $video.data('index') + ']').length > 0) {
					
					$video.data('videojs').on('timeupdate', function () {
						
						var currentTime	=	this.currentTime(),
							duration	=	this.duration(),
							progress	=	currentTime / duration,
							right		=	progress * 360,
							left		=	progress * 360;
						
						if (progress > 0.5) {
							
							right	=	180;
							
						}
						
						if ($video.hasClass('active')) {
							
							if (Modernizr.csstransitions) {
								
								$artDots.filter('[data-index=' + $video.data('index') + ']').find('.dot-circle').find('.circle-right').css({
									transitionDuration	:	'0ms',
									transform			:	'rotate(' + right + 'deg)'
								}).siblings('.circle-left').css({
									transitionDuration	:	'0ms',
									transform			:	'rotate(' + left + 'deg)'
								});
								
							} else {
								
								$artDots.filter('[data-index=' + $video.data('index') + ']').children().css({ opacity : progress })
								
							}
							
						}
						
					});
					
				}
				
				if (parseInt($video.data('audio'), 10) === 1) {
					
					$artwork
						.find('.slide-caps')
							.children('.caption')
								.eq($video.data('index'))
									.find('.volume-btn')
										.addClass('audio-on');
					
				} else {
					
					$video
						.data('videojs')
							.muted(true);
					
				}
				
				$video
					.addClass('initialized')
				
			}
			
		},
		startShow		= function () {
			
			positionCap(currSlide);
				
			if (showStarted === false) {
				
				activateSlide(currSlide);
				
				if (!Modernizr.csstransitions) {
					
					$artDots.eq(currSlide).children().css({ opacity : 0 }).stop(true).animate({ opacity : 1 }, $artContent.eq(currSlide).data("duration"));
					
				}
				
				$artDots.eq(currSlide).addClass("active");
				
				showTimer	= setTimeout(function () {
					runSlideshow(currSlide + 1);
				}, $artContent.eq(currSlide).data("duration"));
				
				lastSlideStart	= new Date().getTime();
				
				//initialize all the video slides
				$artContent.filter('.video').each(initVideo);
				
				if ($artContent.eq(currSlide).hasClass('video') && typeof $artContent.eq(currSlide).data('videojs') !== 'undefined') {
					
					$artContent.eq(currSlide).data('videojs').ready(function () {
						
						if (parseInt($(this.el_).closest('.content').data('autoplay'), 10) === 1 && currSlide === $(this.el_).closest('.content').data('index')) {
							
							if (this.readyState() === 4) {
								
								if (windowIsActive === true) {
									
									//now that the video can play, make it visible
									$(this.el_)
										.find('video')
											.filter('.vjs-tech')
												.addClass('active');
									
									this.play();
									
								}
								
							} else {
								
								this.one('canplay', function () {
									
									//now that the video can play, make it visible
									$(this.el_)
										.find('video')
											.filter('.vjs-tech')
												.addClass('active');
									
									if (windowIsActive === true && currSlide === $(this.el_).closest('.content').data('index')) {
										
										this.play();
										
									}
									
								});
								
							}
							
						}
						
					});
					
				}
				
			}
			
		},
		//randomizeCap	= function (slideIndex) {
		//	
		//	var rand1	= Math.round(Math.random() * 1),
		//		rand2	= Math.round(Math.random() * 1);
		//	
		//	$artContent.eq(slideIndex).removeClass("cap-center " + captionPos[0].join(" ") + " " + captionPos[1].join(" ")).addClass(captionPos[0][rand1] + " " + captionPos[1][rand2]);
		//	
		//},
		positionThumbs	= function (index) {
			
			//if this slide has a caption
			if ($artContent.eq(index).hasClass("has-cap")) {
				
				//place thumbs above the caption for mobile ui
				$artwork.find(".thumb-dots").addClass('has-cap');
				
			} else {
				
				$artwork.find(".thumb-dots").removeClass('has-cap');
				
			}
			
		},
		fancyDotDeact	= function (index) {
			
			var durSinceLastStart	= Math.abs(new Date().getTime() - lastSlideStart),
				currFullDuration	= parseInt($artContent.eq(index).data("duration"), 10),
				halfDurationLeft	= (currFullDuration - durSinceLastStart),
				percentageLeft		= (halfDurationLeft / currFullDuration),
				circleDelay			= (showTransDur / 2);
			
			if (percentageLeft < 0.5) {
				circleDelay	= (showTransDur / 2) - (percentageLeft * showTransDur);
			}
			
			$artDots.eq(index).find(".dot-inner").css({ 'transition-duration' : showTransDur + 'ms' });
			$artDots.eq(index).find(".dot-circle").css({ 'transition-delay' : circleDelay + 'ms' });
			$artDots.eq(index).find(".circle-left").css({ 'transition-duration' : showTransDur + 'ms' });
			$artDots.eq(index).find(".circle-right").css({ 'transition-duration' : (showTransDur / 2) + 'ms', 'transition-delay' : circleDelay + 'ms' });
			
		},
		fancyDotReset	= function (index) {
			
			$artDots.eq(index).find(".dot-inner").css({ 'transition-duration' : $artContent.eq(index).data("duration") + 'ms' });
			$artDots.eq(index).find(".dot-circle").css({ 'transition-delay' : ($artContent.eq(index).data("duration") / 2) + 'ms' });
			$artDots.eq(index).find(".circle-left").css({ 'transition-duration' : $artContent.eq(index).data("duration") + 'ms' });
			$artDots.eq(index).find(".circle-right").css({ 'transition-duration' : ($artContent.eq(index).data("duration") / 2) + 'ms', 'transition-delay' : '' });
			
		},
		positionCap		= function (index) {
			
			if (typeof index === 'undefined') {
				var index	= currSlide;
			}
			
			//if this slide has an "elegant" caption then slide the caption-viewport to vertical center
			if ($artContent.eq(index).hasClass("cap-elegant")) {
				
				if ($('html').hasClass('ui-mobile')) {
					
					//$artContent.eq(index).find(".cap-viewport").css({ marginTop : '' });
					$artCaption.filter("[data-index=" + index + "]").find(".cap-viewport").css({ marginTop : '' });
					
				} else {
					
					var capHeight			= $artContent.eq(index).height(),
						//capViewportHeight	= $artContent.eq(index).find(".cap-viewport").height(),
						capViewportHeight	= $artCaption.filter("[data-index=" + index + "]").find(".cap-viewport").height(),
						newMarginTop		= (capHeight / 2) - (capViewportHeight / 2) - 50;
					
					//make sure the new margin doesn't push the content out of view
					if (newMarginTop + capViewportHeight > capHeight) {
						newMarginTop	= (capHeight - capViewportHeight) / 2;
					}
					
					if (newMarginTop < 0) {
						newMarginTop	= 0;
					}
					
					//$artContent.eq(index).find(".cap-viewport").css({ marginTop : newMarginTop });
					$artCaption.filter("[data-index=" + index + "]").find(".cap-viewport").css({ marginTop : newMarginTop });
					
				}
				
			}
			
		},
		activateSlide	= function (index, oldIndex) {
			
			//remove display:none from slide
			$artContent.eq(index).removeClass("hide");
			
			//remove display:none from associated caption
			$artCaption.filter("[data-index=" + index + "]").removeClass("hide");
			
			//let the "hide" class change settle and then position captions
			setTimeout(function () {
					
				//position caption
				positionCap(index);
				
				//position thumbs
				positionThumbs(index);
					
			}, 25);
			
			if (Modernizr.csstransitions) {
				
				//activate new dot
				$artDots.eq(index).addClass("active");
				
				setTimeout(function () {
					
					//activate new content
					$artContent.eq(index).addClass("active");
					
					//activate new caption
					$artCaption.filter("[data-index=" + index + "]").addClass("active");
					
				}, 25);
				
			} else {
				
				//animate in the new dot
				$artDots.eq(index).children().stop().animate({ opacity : 1 }, $artContent.eq(index).data("duration"));
				
				//activate new dot to save state
				$artDots.eq(index).addClass("active");
				
				//activate new content
				$artContent.eq(index).css({ opacity : 0 }).stop(true).animate({ opacity : 1 }, showFadeDur, "easeInOutCubic", function () {
					
					//add "active" class to save state
					$artContent.eq(index).addClass("active");
					
				});
				
				//activate caption
				$artCaption.filter("[data-index=" + index + "]").add($artCaption.filter("[data-index=" + index + "]").prev("css3-container")).css({ opacity : 0, display : '' }).stop(true).delay(capWait).animate({ opacity : 1 }, capDur, "easeInOutCubic", function () {
					
					//add "active" class to save state
					$artContent.filter("[data-index=" + index + "]").addClass("active");
					
				});
				
			}
			
		},
		deactivateSlide	= function (index) {
			
			if ($artContent.eq(index).hasClass('video')) {
				
				$artDots.filter('[data-index=' + $artContent.eq(index).data('index') + ']').find('.dot-circle').children().css({
					transitionDuration	:	'',
					transform			:	''
				});
				
				if ($artContent.eq(index).hasClass('video') && typeof $artContent.eq(index).data('videojs') !== 'undefined') {
					
					setTimeout(function () {
						
						$artContent.eq(index).data('videojs').pause();
						$artContent.eq(index).data('videojs').currentTime(0);
						
					}, 1000);
					
				}
				
			}
			
			if (Modernizr.csstransitions) {
				
				//deactivate content
				$artContent.eq(index).removeClass("active");
				
				//deactivate caption
				$artCaption.filter("[data-index=" + index + "]").removeClass("active");
				
				//update transition duration for dot
				fancyDotDeact(index);
				
				setTimeout(function () {
					//deactivate old dot
					$artDots.eq(index).removeClass("active");
				}, 25);
				
				setTimeout(function () {
					
					//completely hide content
					$artContent.eq(index).addClass("hide");
					
					//completely hide caption
					$artCaption.filter("[data-index=" + index + "]").addClass("hide");
					
					//reset transition duration of dot
					fancyDotReset(index);
					
				}, showTransDur);
				
			} else {
				
				//animate old dot out of activity
				$artDots.eq(index).children().stop().animate({ opacity : 0 }, showTransDur);
				
				//deactivate old dot to save state
				//setTimeout(function () {
					$artDots.eq(index).removeClass("active");
				//}, 25);
				
				
				//deactivate content
				$artContent.eq(index).css({ opacity : 1 }).stop(true).animate({ opacity : 0 }, showFadeDur, "easeInOutCubic", function () {
					
					//keep state
					$artContent.eq(index).addClass("hide").removeClass("active");
					
				});
				
				//deactivate caption
				$artCaption.filter("[data-index=" + index + "]").add($artCaption.filter("[data-index=" + index + "]").prev("css3-container")).css({ opacity : 1 }).stop(true).animate({ opacity : 0 }, capDur, "easeInOutCubic", function () {
					$(this).css({ display : 'none' });
				});
				
			}
			
		},
		runSlideshow	= function (newIndex) {
			
			showStarted	= true;
			
			lastSlideStart	= new Date().getTime();
			
			//only run when there is more than one slide
			if ($artContent.length < 2) {
				return false;
			}
			
			if (newIndex === currSlide) {
				//maybe add a delay (TODO), otherwise do nothing
				return false;
			}
			
			var oldSlide	= currSlide;
			
			clearTimeout(showTimer);
			
			deactivateSlide(oldSlide);
			
			if (newIndex >= $artContent.length || newIndex < 0) {
				newIndex	= 0;
			}
			currSlide	= newIndex;
			
			//randomize caption placement if needed
			//if ($artContent.eq(currSlide).hasClass("cap-random")) {
			//	randomizeCap(currSlide);
			//}
			
			activateSlide(newIndex);
			
			if ($artContent.eq(newIndex).hasClass('video')) {
				
				if (windowIsActive) {
					
					setTimeout(function () {
						
						$artContent.eq(newIndex).data('videojs').play();
						
					}, 5000);
					
				}
				
			} else {
				
				showTimer	= setTimeout(function () {
					
					runSlideshow(newIndex + 1);
					
				}, parseInt($artContent.eq(currSlide).data("duration"), 10) + showTransDur);
				
			}
			
		},
		pauseCurrentVideo	=	function () {
			
			//pause a video if it's playing in mobile ui
			if ($('html').hasClass('ui-mobile')) {
				
				if ($artContent.filter('.active').filter('.video').length && typeof $artContent.filter('.active').filter('.video').data('videojs') !== 'undefined') {
					
					$artContent
						.filter('.active')
							.filter('.video')
								.data('videojs')
									.pause();
					
				}
				
			}
			
		},
		playCurrentVideo	=	function () {
			
			//play a video if it's paused
			if ($artContent.filter('.active').filter('.video').length && $artContent.filter('.active').data('playing') && typeof $artContent.filter('.active').filter('.video').data('videojs') !== 'undefined') {
				
				$artContent
					.filter('.active')
						.filter('.video')
							.data('videojs')
								.play();
			
			}
			
		};
	
	//for old browsers, using jquery.backgroundSize.js
	$artContent.css( "background-size", "cover" );
	
	$(function () {
		setTimeout(startShow, 10000);
		positionCap();
	});
	
	$(window).on("resize.artwork", function () {
		clearTimeout(resizeTimer);
		resizeTimer	= setTimeout(function () {
			positionCap();
			resizeVideoArtwork();
		}, 125);
	}).on("load.artwork", function () {
		
		resizeVideoArtwork();
		$artwork.addClass("loaded");
		startShow();
		
	});
	
	$artCaption.find(".cap-viewport, .overlay").on("mouseleave", function () {
		
		var $this	= $(this);
		
		showHoverTimer	= setTimeout(function () {
			$this.closest(".caption").removeClass("hover");
			showTimer	= setTimeout(function () {
				runSlideshow(currSlide + 1);
			}, $artContent.eq(currSlide).data("duration"));
			
			lastSlideStart	= new Date().getTime();
			
			fancyDotReset($this.closest(".caption").data("index"));
			$artDots.eq($this.closest(".caption").data("index")).removeClass("reset");
		}, 75);
		
	}).on("mouseenter", function () {
		
		var $this	= $(this);
		
		fancyDotDeact($this.closest(".caption").data("index"));
		
		setTimeout(function () {
			$artDots.eq($this.closest(".caption").data("index")).addClass("reset");
		}, 25);
		
		clearTimeout(showHoverTimer);
		clearTimeout(showTimer);
		
		$(this).closest(".caption").addClass("hover");
		
	}).on("click", function () {
		
		if ($(this).closest('.caption').hasClass('cap-transparent'))	return;
		
		var $link	= $(this).closest('.caption').find("a");
		if ($link.length > 0) {
			window.location	= $link.eq(0)[0].href;
		}
	});
	
	$artDots.on("click", function (event) {
		
		event.preventDefault();
		event.stopPropagation();
		
		clearTimeout(showTimer);
		
		$(this).trigger("mouseleave");
		
		var newSlide	= parseInt($(this).data("index"), 10);
		
		runSlideshow(newSlide);
		
	}).on("mouseleave", function () {
		
		if (!Modernizr.touch) {
			dotOverlayTimer	= setTimeout(function () {
				$artDotOver.fadeOut(250, "easeInOutCubic");
			}, 75);
		}
		
	}).on("mouseenter", function () {
		
		clearTimeout(dotOverlayTimer);
		
		if (!Modernizr.touch) {
			//hide all dot overlays, select the one associated with this dot, set the position for the selected overlay, then fade it into view
			$artDotOver.hide().eq($(this).data("index")).css({ left : $(this).offset().left - 72 }).fadeIn(250, "easeInOutCubic");
		}
		
	});
	
	$artDotOver.on("click", function (event) {
		
		$(this).trigger("mouseleave").prev().trigger("click");
		
	}).on("mouseleave", function () {
		
		dotOverlayTimer	= setTimeout(function () {
			$artDotOver.fadeOut(250, "easeInOutCubic");
		}, 75);
		
	}).on("mouseenter", function () {
		
		clearTimeout(dotOverlayTimer);
		
	});
	
	$(window).on('blur.artwork', function () {
		
		windowIsActive	=	false;
		
		if ($artContent.eq(currSlide).hasClass('video') && typeof $artContent.eq(currSlide).data('videojs') !== 'undefined') {
			
			$artContent.eq(currSlide).data('videojs').pause();
			
			$artCaption
				.eq(currSlide)
					.find('.play-btn')
						.removeClass('hide')
					.end()
					.find('.pause-btn')
						.addClass('hide');
			
		}
		
	}).on("focus.artwork", function (event) {
		
		windowIsActive	=	true;
		
		if ($artContent.eq(currSlide).hasClass('video') && $artContent.eq(currSlide).data('playing') && typeof $artContent.eq(currSlide).data('videojs') !== 'undefined') {
			
			$artContent.eq(currSlide).data('videojs').play();
			
			$artCaption
				.eq(currSlide)
					.find('.play-btn')
						.addClass('hide')
					.end()
					.find('.pause-btn')
						.removeClass('hide');
			
		}
		
	});
	
	$artCaption
		.find('.scroll-to-content')
			.on('click', function (event) {
				
				event.preventDefault();
				event.stopPropagation();
				
				//show notification that content exists below
				$('html, body')
					.animate({ scrollTop : $(window).height() - $('#header').height() }, 750, 'easeInOutCubic');
				
			});
	
})(jQuery);



/*!
 * Copyright (C) 2014-2023, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * WendoverFun.com Custom JS - 1/10/2013
 *
 *	Changes:
 *				2014-04-29	Updated references of 211 to 130 for header update.
 *				2014-05-07	Updated references of 130 to 85 for header update.
 *				2014-05-07	Updated references of 85 to 100 for header update.
 *				2014-11-12	Updated the SSL Notify process to only check every 5 minutes for fails and every 1 hour for successes (less load on SUGAR).
 *							Added trimLeft/trimRight polyfills for IE.
 *				2016-12-14	Added confirmation message when clicking links to external websites.
 *				2023-03-22	Remove #subnav "sticky" polyfill.
 *				2023-05-31	Use new booking domains.
 */

(function ($) {
	
	//globals
	var $container	= $('#container'),
		$header		= $('#header'),
		$content	= $('#content'),
		$footer		= $('#footer'),
		dims		= {
			window	: {
				w		: $(window).width(),
				h		: $(window).height(),
				timer	: null
			},
			document	:	{
				h	:	$(document).height()
			}
		},
		responsive	= {
			current	: 'ui-desktop',
			points	: [ 767, 1024, 1280 ],
			classes	: [ 'ui-mobile', 'ui-tablet', 'ui-desktop', 'ui-widescreen' ]
		},
		lastRenderedScroll	=	-1,
		currentScroll		=	-1;

  const hotelBookingDomain = ('dev.' === location.hostname.substring(0, 4))
    ? 'https://devbooking.wendoverfun.com:9152'
    : 'https://booking.wendoverfun.com';

  $('html').data('hotelBookingDomain', hotelBookingDomain);
	
	for (var i = 0, l = responsive.classes.length; i < l; i++) {
		if ($('html').hasClass(responsive.classes[i])) {
			responsive.current	= responsive.classes[i];
			break;
		}
	}
	
	window.wnresponsive	= { current : responsive.current };
	
	//initialize modernizr
	if (typeof window.Modernizr === "undefined") {
		window.Modernizr	= {
				//csstransforms	: $("html").hasClass("csstransforms"),
				csstransitions	: $("html").hasClass("csstransitions"),
				prefixed		: function (str) {
					return str;
				}
			};
	}
	
	//set datepicker options
	if (typeof $.fn.datepicker !== 'undefined') {
		
		$.fn.datepicker.language['en'] = {
			days		:	['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			daysShort	:	['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			daysMin		:	['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			months		:	['January','February','March','April','May','June', 'July','August','September','October','November','December'],
			monthsShort	:	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			today		:	'Today',
			clear		:	'Clear',
			dateFormat	:	'mm/dd/yyyy',
			timeFormat	:	'hh:ii aa',
			firstDay	:	0
		};
		
	}
	
	$footer.find(".facebook-logo").on("click", function () {
		window.pepTracking.event("Social", "Facebook - Footer Link", window.location.pathname, 0, false);
	}).end().find(".logos").find("a").on("click", function () {
		window.pepTracking.event("Footer", this.className, window.location.pathname, 0, false);
	});
	
	if (responsive.current === 'ui-mobile') {
		$footer.find(".nav").find(".header").children("a").on("click", function () {
			$(this).parent().toggleClass("active");
			return false;
		});
	}
	
	//footer animation code
	var footerTimer		= null,
		footerState		= 0;
		
	//MAIN NAVIGATION CODE//
	var nav			= {
			element		: $('#nav'),
			origBG		: $('#nav').css("background-color"),
			links		: $('#nav').children('.nav-grad').children('a'),
			gradSize	: 125,
			timer1		: null,
			timer2		: null,
			x			: 0,
			y			: 0,
			o			: 0,
			increment	: 0.03,
			events		: {
				mouseenter	: function () {
					if (responsive.current !== 'ui-mobile') {
					//console.log($(this).text(), 'enter');
					//if ($.data(this, 'state') !== 'enter') {console.log(1);
						//nav.links.filter(function () {
							
						//	return $(this).prev('.nav-over-wrapper').length;
						//}).trigger('mouseleave');
						$.data(this, 'state', 'enter');
						
						var $this	= $(this),
							$that	= $this.prev('.nav-over-wrapper');
						
						$that.data('state', 'enter').show();
						clearTimeout($that.data('timer'));
						//$that.stop(true).css({ display : 'block' }).delay(100).animate({ opacity : 1 }, 375, 'easeInOutCubic');//.show();
						//$that.css('display', '').stop(true, false).fadeTo(250, 1);
					//}
					}
				},
				mouseleave	: function () {
					if (responsive.current !== 'ui-mobile') {
					//console.log($(this).text(), 'leave');
					//if ($.data(this, 'state') !== 'leave') {console.log(1);
						$.data(this, 'state', 'leave');
						var $this	= $(this);
						$this.prev('.nav-over-wrapper').data('timer', setTimeout(
							function () {
								$this.prev('.nav-over-wrapper').data('state', 'leave').hide();
								//$this.prev('.nav-over-wrapper').stop(true).animate({ opacity : 0 }, 375, 'easeInOutCubic', function () { $(this).css({ display : '' }); });//.hide();//.stop(true, true).fadeOut();
							}, 100)
						);
					//}
					}
				}
			}
		},
		prefixed	= window.Modernizr.prefixed('transform') || '';
	
	//bind to hover events for main nav links
	nav.links.filter(function () {
		
		//only bind to nav items that have a menu to display
		return $(this).prev('.nav-over-wrapper').length;
	}).on('mouseleave', nav.events.mouseleave).on('mouseenter', nav.events.mouseenter).prev().on('mouseleave', function () {
		
		//call the mouseleave function where `this` is the actual nav button
		nav.events.mouseleave.call($(this).next()[0]);
	}).on('mousemove', false).on('mouseenter', function () {
		
		//call the mouseenter function where `this` is the actual nav button
		nav.events.mouseenter.call($(this).next()[0]);
	}).find(".nav-over-page").on('click', function () {
		window.location	= $(this).parent().attr('href');
	});

	nav.element.find(".open-menu").data("state", 0).on("click", function () {
		if ($(this).data("state") === 0) {
			$(this).data("state", 1);
			nav.links.filter(function () {
				return !$(this).hasClass('open-menu') && !$(this).hasClass('reserve-room');
			}).css({ display : 'block' });
			//$subNav.show();
		} else {
			$(this).data("state", 0);
			nav.links.filter(function () {
				return !$(this).hasClass('open-menu') && !$(this).hasClass('reserve-room');
			}).css({ display : 'none' });
			//$subNav.hide();
		}
		return false;
	});
	
	
	//mobile menu code
	$header
		.find('.menu-handle')
			.on('click', function (event) {
				
				event.preventDefault();
				
				if ($header.hasClass('menu-open')) {
					
					//menu is currently open
					$('html')
						.removeClass('scrollbar-hide');
					
					$('body')
						.height('');
					
					$header
						.removeClass('menu-open');
					
				} else {
					
					//menu is currently closed
					$('body')
						.height($container.height());
					
					$('html')
						.addClass('scrollbar-hide');
					
					$header
						.addClass('menu-open');
					
					$('html, body')
						.animate({
							scrollTop	:	0
						}, 250, 'easeInOutCubic');
					
				}
				
				window.location.hash	=	'reset';
				
			});
	
	
	//subnav code
	var $subNav				= $("#subnav"),
		$rightSideWrapper	= $("#right-side-wrapper"),
		subTimer			= null,
		oldTop				= 0,
		subNavOffsetStyle	=	(Modernizr.csstransforms)
									?	Modernizr.prefixed('transform')
									:	'top';
	if ($subNav.length){
		
		$subNav.find(".header").data('state', 0).on("click.subnav", function (event) {
			
			if (responsive.current === 'ui-mobile') {
				
				if ($(this).data('state') === 0) {
					
					$(this).data('state', 1).addClass('active').closest('ul').next().find('li').toggle();
					
					//stop link from executing
					event.preventDefault();
					
				}
				
				//if state=1 then the link will be followed
				
			}
			
		});
	}
	
	//#nav .reserve-room code
	var $navReserveRoom	= nav.element.find(".reserve-room");
	
	$navReserveRoom
		.data({
			aniTimer	:	null,
			clickTimer	:	null,
			clickOK		:	true
		})
		.on("click", function (event) {
			
			event.preventDefault();
			
			if (!$navReserveRoom.data('clickOK'))	return;
			
			$navReserveRoom
				.data('clickOK', false);
			
			$navReserveRoom
				.data('clickTimer', setTimeout(function () {
					
					$navReserveRoom
						.data('clickOK', true);
					
				}, 500));
			
			if ($theOverlay.data("state") == 0) {
				
				//month-day-year-stay length-# of guests-property-room type-preference-resnet-code
				window.location.hash	= 'reserve-choose-date----1-2----';
				
			} else {
				
				//set hash
				window.location.hash	= 'reset';
				
			}
			
		});
	
	var overlayLoaderTimer	= null;
	function showOverlayLoader(timeout) {
		
		if (typeof timeout === 'undefined') {
			var timeout	= 500;
		}
		
		if (!$("#overlay-loader").length) {
			
			//wait a quarter second to make sure the loader should be shown
			overlayLoaderTimer	= setTimeout(function () {
				var $ele	= $('<div id="overlay-loader" style="opacity:0;filter:alpha(opacity=0);" />').append('<span><img src="/library/images/global/loading-dot-active.png" /></span><span><img src="/library/images/global/loading-dot-active.png" /></span><span><img src="/library/images/global/loading-dot-active.png" /></span><span><img src="/library/images/global/loading-dot-active.png" /></span><span><img src="/library/images/global/loading-dot-active.png" /></span>');
				$ele.appendTo("body").fadeTo(750, 1, 'easeInOutCubic');
				
				var overlayState	= 0,
					overlayFunction	= function () {
						if (overlayState === 0) {
							overlayState	= 1;
							var overlayCSS	= {
								width		: 50,
								height		: 50,
								marginTop	: -25,
								marginLeft	: -25
								};
						} else {
							overlayState	= 0;
							var overlayCSS	= {
								width		: 0,
								height		: 0,
								marginTop	: 0,
								marginLeft	: 0
								};
						}
						for (var i = 0; i < 5; i++) {
							var tmpI	= i;
							if (overlayState === 0) {
								tmpI = 4 - i;
							}
							$ele.children().eq(i).children().delay(250 * tmpI).animate(overlayCSS, 500, 'easeInOutCubic');
						}
					};
				overlayFunction();
				overlayLoaderTimer	= setInterval(overlayFunction, 1500);
			}, timeout);
		}
	}
	
	function hideOverlayLoader() {
		clearInterval(overlayLoaderTimer);
		if ($("#overlay-loader").length) {
			$("#overlay-loader").stop(true, true).fadeTo(750, 0, 'easeInOutCubic', function () {
				$(this).remove();
			});
		}
	}
	
	var $theOverlay				= $("#reserve-wrapper")
									.data({
										state		:	0,
										showgate	:	'',
										timer		:	null
									})
									.on("click", function (event) {
										
										if (typeof event.target.id !== 'undefined' && event.target.id === 'reserve-wrapper') {
											$navReserveRoom.trigger("click");
										}
										
									}),
		globalWindowTimer		= null,
		globalHistory			= [],
		reverseFlag				= false,
		hashInterval			= null,
		lastFooterRender		= -1,
		lastWindowHRender		= 0,
		reserveCalendarWidth	=	340,
		reserveRoomChoosePropertyTimer	=	null,
		footerInitiated					=	false;
	
	$theOverlay
		.on('click', function (event) {
			
			event.stopPropagation();
			
		});
	
	window.updateLastFooterRender	=	function (newValue) {
		
		if (typeof newValue === 'number')	lastFooterRender	=	parseInt(newValue);
		
	}
	
	function renderFooter() {
		
		//if ($container.data("id") !== 0 && responsive.current !== 'ui-mobile') {
		if (responsive.current !== 'ui-mobile') {
			
			if (currentScroll !== lastFooterRender || lastWindowHRender !== dims.window.h) {
				
				//save this render point
				lastWindowHRender	= dims.window.h;
				lastFooterRender	= currentScroll;
				
				if (bottomProximity > 165) {
					
					//close the footer
					$footer
						.css({ bottom : '' });
					
				} else {
					
					//open the footer
					$footer
						.css({ bottom : bottomProximity * -1 });
					
					if (!footerInitiated) {
						
						footerInitiated	=	true;
						
						$footer.addClass('initiated');
						
					}
					
				}
				
				if (bottomProximity < 100) {
					
					$footer
						.addClass('active');
					
				} else if (bottomProximity >= 100) {
					
					//click the "more" button if not enough of the footer is showing and it's active
					$footer
						.removeClass('active')
					
				}
				
			}
			
		}
		
	}
	
	function changeButtonText($ele, newText, transitionClass) {

		if (typeof newText !== 'string')			return;
		if (typeof transitionClass !== 'string')	return;
		
		try {

			if ($.trim($ele.children('span').text()) === $('<span>' + newText + '</span>').text())		return;
			
		} catch (e) {}
		
		clearTimeout($ele.data('aniTimer'));

		$ele
			.children('span')
				.removeClass('in out')
				.addClass('hide ' + transitionClass);
		
		$ele
			.data('aniTimer', setTimeout(function () {
				
				$ele
					.children('span')
						.filter('.hide, .new')
							.remove();
				
				$ele
					.append('<span class="new ' + transitionClass + '">' + newText + '</span>');
				
				$ele
					.data('aniTimer', setTimeout(function () {
						
						$ele
							.children('span')
								.removeClass('new');
						
					}, 33));
				
			}, 125));
	}
	
	function changeReservationButtonText(newText, transitionClass) {
		
		changeButtonText($navReserveRoom, newText, transitionClass);
		
	}
	
	function changeOPCButtonText(newText, transitionClass) {

		changeButtonText(nav.element.find('.opc-btn'), newText, transitionClass);

	}
	
	function addMonths(date, months) {
		
	    var result = new Date(date);
	    
	    result.setMonth(result.getMonth() + months);
	    
	    return result;
	    
	}
	
	function addDays(date, days) {
		
	    var result = new Date(date);
	    
	    result.setDate(result.getDate() + days);
	    
	    return result;
	    
	}
	
	function treatAsUTC(date) {
		
	    var result = new Date(date);
	    
	    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
	    
	    return result;
	    
	}

	function daysBetween(startDate, endDate) {
	    
		var millisecondsPerDay = 24 * 60 * 60 * 1000;
		
	    return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
	    
	}
	
	function validateCheckInDate() {
		
		//if the check-in date is past or on the same date as checkout, update check-out
		var $checkIn = $theOverlay.find('.check-in').find('input'),
			$checkOut = $theOverlay.find('.check-out').find('input'),
			checkInDate = $checkIn.data('datepicker').selectedDates[0],
			checkOutDate = $checkOut.data('datepicker').selectedDates[0];
		
		if (typeof checkOutDate !== 'undefined') {
			
			if (checkOutDate <= checkInDate) {
				
				$checkOut
					.data('datepicker')
						.selectDate(addDays(checkInDate, 1));
				
			}
			//make sure the check-out date is no more than 14 days after the check-in date
			else if (daysBetween(checkInDate, checkOutDate) > 14) {
				
				$checkOut
					.data('datepicker')
						.selectDate(addDays(checkInDate, 14));
				
			}
			
		}
		
		//$checkIn
		//	.val(reservationWidgetPrepareDate(checkInDate));
		
		$checkOut
			.data('datepicker')
				.update({
					minDate	:	addDays(checkInDate, 1)
				});
		
		validateCheckOutDate();
		
	}
	
	function validateCheckOutDate() {
		
		//make sure the check-out date is after the check-in date
		var $checkIn = $theOverlay.find('.check-in').find('input'),
			$checkOut = $theOverlay.find('.check-out').find('input'),
			checkInDate = $checkIn.data('datepicker').selectedDates[0],
			checkOutDate = $checkOut.data('datepicker').selectedDates[0];
		
		if (typeof checkInDate !== 'undefined') {
			
			if (checkInDate >= checkOutDate) {
				
				$checkOut
					.data('datepicker')
						.selectDate(addDays(checkInDate, 1));
				
				showOverlayDialog({
					alertMode: true,
					confirmAccept: 'OK',
					confirmTitle: '',
					confirmBody: 'Your check-out date must be after your check-in date.'
				});
				
				//reservationWidgetShowErrorMsg('', '14 Day Max');
				
				return;
				
			}
			//make sure the check-out date is no more than 14 days after the check-in date
			else if (daysBetween(checkInDate, checkOutDate) > 14) {
				
				$checkOut
					.data('datepicker')
						.selectDate(addDays(checkInDate, 14));
				
				showOverlayDialog({
					alertMode: true,
					confirmAccept: 'OK',
					confirmTitle: 'Stay Too Long',
					confirmBody: 'Your stay length can be a maximum of 14 days.'
				});
				
				//reservationWidgetShowErrorMsg('Your stay length can be a maximum of 14 days.', '14 Day Max');
				
				return;
				
			}
			
			if (typeof checkOutDate !== 'undefined') {
				
				//update the "nights" input
				$theOverlay
					.find('.nights')
						.find('input')
							.val(daysBetween(checkInDate, checkOutDate));
				
			}
			
		}
		
		//$checkOut
		//	.val(reservationWidgetPrepareDate(checkOutDate));
		
	}
	
	function findCalendarDate($ele) {
		
		var year = $ele.closest('.calendar').data('year'),
			month = $ele.closest('.calendar').data('month'),
			day = parseInt($ele.find('.day-number').text());
		
		return new Date(year, (month - 1), day);
		
	}
	
	function findCalendarDay(date) {
		
		return $theOverlay
				.find('.calendar')
					.filter(function () {
						
						return parseInt($(this).data('year'), 10) === date.getFullYear() && parseInt($(this).data('month'), 10) === (date.getMonth() + 1);
						
					})
						.find('.calendar-day')
							.filter(function () {
								
								return parseInt($(this).find('.day-number').text(), 10) === date.getDate();
								
							});
		
	}
	
	function updateCalendarDays() {
		
		var $checkIn		=	$theOverlay.find('.check-in').find('input'),
			$checkOut		=	$theOverlay.find('.check-out').find('input'),
			checkInDate		=	$checkIn.data('datepicker').selectedDates[0],
			checkOutDate	=	$checkOut.data('datepicker').selectedDates[0],
			$calendarMonths	=	$theOverlay.find('.calendar'),
			$firstDay		=	{},
			$lastDay		=	{};
		
		$calendarMonths
			.find('.calendar-day')
				.removeClass('hover');
		
		if (typeof checkInDate !== 'undefined') {
			
			$firstDay = findCalendarDay(checkInDate).addClass('hover');
			
			//animate the chosen month to be visible
			var currMonth	=	$theOverlay.find('.inner-viewport').data('curr-month'),
				selMonth	=	$firstDay.closest('.calendar-wrapper').index();
			
			if (currMonth !== selMonth && currMonth !== selMonth - 1) {
				
				$reserveWrapper
					.find(".inner-viewport")
						.data('curr-month', selMonth)
						.stop(true)
						.animate({
							scrollLeft : reserveCalendarWidth * selMonth
						}, 750, 'easeInOutCubic');
				
			}
			
		}
		
		if (typeof checkOutDate !== 'undefined') {
			
			$lastDay = findCalendarDay(checkOutDate).addClass('hover');
			
			//highlight all inbetween dates if necessary
			if ($firstDay[0] !== $lastDay[0]) {
				
				var $allDays = $calendarMonths.find('.calendar-day');
				
				$allDays
					.removeClass(function (i, className) {
						
						//remove all delay classes
						return (className.match(/(^|\s)delay-\S+/g) || []).join(' ');
						
					})
					.slice($allDays.index($firstDay), $allDays.index($lastDay))
						.each(function (i) {
							
							$(this)
								.addClass('delay-' + i);
							
						})
						.addClass('hover');
				
			}
			
		}
		
		reserveWidgetCheckIfNextStepReady();
		
	}
	
	function reserveWidgetCheckIfNextStepReady() {
		
		if ($theOverlay.find('.reserve-properties').hasClass('property-chosen') && $theOverlay.find('.calendar-day').filter('.hover').length >= 2) {
			
			//a property is chosen and at least two days have been chosen
			$theOverlay
				.find('.reserve-calendar-next')
					.addClass('highlight')
        [0].focus();
			
		} else {

			$theOverlay
				.find('.reserve-calendar-next')
					.removeClass('highlight');
			
		}
		
	}
	
	$(function () {
		
		ajaxLinkegisterCallback(
			'RESERVE-ROOM-CHOOSE-DATES',
			function () {
				
			}
		);
		
		ajaxLinkegisterCallback(
			'RESERVE-ROOM-CHOOSE-PROPERTY',
			function () {
				
				if (wnresponsive.current === 'ui-mobile') {
					
					$theOverlay
						.children('.reserve-viewport')
							.animate({
								scrollTop	:	0
							}, 350, 'easeInOutCubic');
					
				}
				
				$theOverlay
					.find('.reserve-properties')
						.addClass('highlight');
				
				clearInterval(reserveRoomChoosePropertyTimer);
				
				reserveRoomChoosePropertyTimer	=	setInterval(function () {
					
					var nextIndex	=	($theOverlay.find('.reserve-properties').find('.prop').filter('.highlight').length)
											?	$theOverlay.find('.reserve-properties').find('.prop').filter('.highlight').index() + 1
											:	0;
					
					if (nextIndex > 2)	nextIndex	=	0;
											
					$theOverlay
						.find('.reserve-properties')
							.children()
								.removeClass('highlight')
								.eq(nextIndex)
									.addClass('highlight');
					
				}, 1500);
				
			}
		);
		
	});
	
	function renderScrollDifference() {
		
		if (lastRenderedScroll !== currentScroll) {
			
			renderFooter();
			
			if (responsive.current !== 'ui-mobile' && responsive.current !== 'ui-tablet') {
				
				$theOverlay
					.add($opcBtn.data('$loginForm'))
					.css({
						top		:	currentScroll > nav_offset	? 33	: 100 - currentScroll
					});
				
			} else {
				
				$theOverlay
					.add($opcBtn.data('$loginForm'))
					.css({
						top		:	''
					});
				
			}
			
			lastRenderedScroll	=	currentScroll;
			
		}
		
		requestAnimationFrame(renderScrollDifference);
		
	}
	
	function calculateBottomProximity() {
		
		bottomProximity	= dims.document.h - (currentScroll + dims.window.h);
		
	}
	
	$(document).on("keydown.global", function (event) {
		if (event.which === 27) {
			window.location.hash	= 'reset';
		}
	});
	$(window).on("scroll.global load.global resize.global", function (event) {
		
		currentScroll	=	$(window).scrollTop();
		
		calculateBottomProximity();
		
	}).on("hashchange.global", function () {
		var theHash		= this.location.hash.replace("#", "");
		
		globalHistory.push(theHash);
		
		clearTimeout($theOverlay.data('timer'));
		
		//NEW
		if (theHash === '' || theHash === 'reset') {
			
			$(window).off('mousewheel.theOverlay');
			
			hideOverlayLoader();
			
			hideLoader();
			
			if ($navReserveRoom.text() !== "RESERVE ROOM") {
				
				changeReservationButtonText('RESERVE<span class="tablet-hidden"> ROOM</span>', 'in');
				
			}
			
			//hide overlay and remove children
			$theOverlay
				.data({ state : 0 })
				.removeClass('active');
			
			$theOverlay
				.data('timer',setTimeout(function () {
					
					$theOverlay
						.children()
							.remove();
					
					//play any slideshows
					$.each($(".slideshow"), function () {
						
						if (typeof this.sliderStart === "function")	this.sliderStart();
						
					});
					
				}, 500));
			
			
			//hide OPC login in header
			$opcBtn
				.removeClass('active');
			
			//hide opc login form
			$opcBtn
				.data('$loginForm')
					.removeClass('active');
			
			changeOPCButtonText($opcBtn.data('textInit'), 'in');
			
		} else if (theHash.substr(0, 20) === 'reserve-choose-date-') {
			
			//close the login form
			if (nav.element.find('.opc-btn').hasClass('active'))	nav.element.find('.opc-btn').trigger('click');
			
			$(window).on('mousewheel.theOverlay', function (event) {
				
				event.preventDefault();
				
			});
			
			showOverlay();
			
			if ($footer.find(".more").data('state') === 'active') {
				$footer.find(".more").trigger('click');
			}
			
			changeReservationButtonText('CLOSE', 'out');
			
			//pause any slideshows
			$.each($(".slideshow"), function () {
				
				if (typeof this.sliderStop === "function")	this.sliderStop();
				
			});
			
			var theData		= theHash.substr(20).split("-"),//month-day-year-stay length-# of guests
				theMonth	= theData[0],
				theYear		= theData[2],
				theDay		= theData[1],
				sMonth		= $.trim(theData[0]),
				sYear		= $.trim(theData[2]),
				sDay		= $.trim(theData[1]),
				eMonth		= '- ',
				eYear		= '-',
				eDay		= '- ',
				propSelect	= theData[5],
				maxDate = addMonths(new Date(), 6),
				checkoutMinDate = addDays(new Date(), 1);
			
			//check for no property passed
			if (propSelect === '') {
				
				//first check for "book now" link on page in call-to-action area
				var $tmpEl	= $("#body").find(".call-to-action").find(".book-link");
				if ($tmpEl.length > 0) {
					
					propSelect	= $tmpEl.data('property');
					
				}
				//otherwise check if this is the Rainbow landing page
				else if (parseInt($container.data('id'), 10) === 29) {
					
					propSelect	= 'WR1';
					
				}
				//otherwise check if this is the Peppermill landing page
				else if (parseInt($container.data('id'), 10) === 39) {
					
					propSelect	= 'WP1';
					
				}
				//otherwise default to Montego Bay
				//else {
				
					//propSelect	= 'WB1';
				
				//}
			}
			
			if (sMonth.length === 0) {
				sMonth	= '- ';
			} else if (sMonth.length < 2) {
				sMonth	= '0' + sMonth + '/';
			} else {
				sMonth	+= '/';
			}
			if (sYear.length === 0) {
				sYear	= '-';
			} else if (sYear.length < 4) {
				tYear	= '20' + sYear;
			}
			if (sDay.length === 0) {
				sDay	= '- ';
			} else if (sDay.length < 2) {
				sDay	= '0' + sDay + '/';
			} else {
				sDay	+= '/';
			}
			
			if (theData[3].length && sMonth !== '- ' && sYear !== '-' && sDay !== '- ') {
				//there is a specified start date and end date
				//eDay	= parseInt(sDay, 10) + parseInt(theData[3], 10);
				
				var s	= new Date(theYear, theMonth - 1, theDay),
					t	= s.getTime(),
					e	= new Date(t + (86400000 * parseInt(theData[3], 10)));
				
				eDay	= $.trim(e.getDate());
				eMonth	= $.trim(e.getMonth() + 1);
				eYear	= $.trim(e.getFullYear());
				
				if (eDay.length < 2) {
					eDay	= '0' + eDay + '/';
				} else {
					eDay	+= '/';
				}
				if (eMonth.length < 2) {
					eMonth	= '0' + eMonth + '/';
				} else {
					eMonth	+= '/';
				}
				if (eYear.length < 4) {
					eYear	= '20' + eYear;
				}
				
			}
			
			while (typeof theData[8] === 'undefined') {
				theData[theData.length]	= '';
			}
			
			//track as event
			window.pepTracking.event('Rooms', 'Choose Date', theHash.substr(20), 0, false);
			window.pepTracking.page('/rooms/choose-date/');
			
			if (theMonth == 0 || theYear == 0) {
				var theDate	= new Date();
				theMonth	= theDate.getMonth() + 1;
				theYear		= theDate.getFullYear();
			}
			
			var $days		= $(),//placeholder for data from AJAX response
				$cal		= $(),//placeholder for data from AJAX response
				propClick	= function (event) {
				event.preventDefault();
					$(this)
						.addClass("active")
						.removeClass('highlight')
							.siblings()
								.removeClass("active highlight")
							.end()
							.closest('.reserve-properties')
								.addClass('property-chosen')
								.removeClass('highlight');
					
					reserveWidgetCheckIfNextStepReady();
					
					clearInterval(reserveRoomChoosePropertyTimer);
							
					
				},
				$ele = $('<div class="reserve-viewport choose-date" />')
						.on('click', function (event) {
							
							event.preventDefault();
							event.stopPropagation();
							
						})
						.append(
							$('<h2 class="viewport-title" />').text("Book Your Hotel Stay")
						).append(
							$('<div class="reserve-properties" />').append(
								$('<a class="prop WR1" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#logo_rainbow"></use></svg><span class="bar"></span></a>').on("click", propClick)
							).append(
								$('<a class="prop WP1" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#logo_peppermill"></use></svg><span class="bar"></span></a>').on("click", propClick)
							).append(
								$('<a class="prop WB1" href="#"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#logo_montego_bay"></use></svg><span class="bar"></span></a>').on("click", propClick)
							)
						).append(
							$('<label class="check-in" title="Click to Change Check-In Date"></label>').append(
								$('<input class="generic-btn" type="text"  value="- - -" />').datepicker({
									language: 'en',
									autoClose: true,
									dateFormat: 'm/d/yyyy',
									minDate: new Date(),
									maxDate: maxDate,
									toggleSelected: false,
									onSelect: function (formattedDate, date, inst) {
										
										validateCheckInDate();
										
										updateCalendarDays();
										
									}
								})
							).append(
								$('<span class="title" />').text("Check-In Date").on("click", function(event){
									event.stopPropagation();
								let datepickerOpen = $ele.find(".check-in input").data("datepicker");
								if(datepickerOpen) {
									datepickerOpen.show();
								}
								})
							)
						).append(
							$('<label class="check-out" title="Click to Change Check-Out Date"></label>').append(
								$('<input class="generic-btn" type="text" value="' + eMonth + eDay + eYear + '" />').datepicker({
									language: 'en',
									autoClose: true,
									dateFormat: 'm/d/yyyy',
									minDate: checkoutMinDate,
									maxDate: maxDate,
									toggleSelected: false,
									onSelect: function (formattedDate, date, inst) {
										
										validateCheckOutDate();
										
										updateCalendarDays();
										
									},
									position: 'bottom right'
								})
							).append(
								$('<span class="title" />').text("Check-Out Date").on("click", function(event){
									event.stopPropagation();
									let datepickerOpen = $ele.find(".check-out input").data("datepicker");
									if(datepickerOpen) {
										datepickerOpen.show();
									}
								})
							)
						).append(
							$('<a class="calendar-prev" href="#" title="Previous Month"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow_left"></use></svg></a>').on("click", function (event) {
								
								event.preventDefault();
								
								var newOffset	=	0;
								
								if ($ele.children(".inner-viewport").data('curr-month') > 0) {
									
									if ($('html').hasClass('ui-mobile')) {
										
										//reset the curr-month if needed
										var currMonth	=	Math.ceil($ele.children(".inner-viewport").scrollLeft() / dims.window.w);
										
										if ($ele.children(".inner-viewport").data('curr-month') !== currMonth)	$ele.children(".inner-viewport").data('curr-month', currMonth);
										
										newOffset	=	dims.window.w * ($ele.children(".inner-viewport").data('curr-month') - 1);
										
									} else {
										
										newOffset	=	reserveCalendarWidth * ($ele.children(".inner-viewport").data('curr-month') - 1);
										
									}
									
									$ele
										.children(".inner-viewport")
											.data('curr-month', ($ele.children(".inner-viewport").data('curr-month') - 1))
											.stop(true)
											.animate({
												scrollLeft : newOffset
											}, 500, 'easeInOutCubic');
									
								}
								
							})
						).append(
							$('<a class="calendar-next" href="#" title="Next Month"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow_right"></use></svg></a>').on("click", function (event) {
								
								event.preventDefault();
								
								var newOffset	=	0;
								
								if ($ele.children(".inner-viewport").data('curr-month') < ($cal.length - 2)) {
									
									if ($('html').hasClass('ui-mobile')) {
										
										//reset the curr-month if needed
										var currMonth	=	Math.floor($ele.children(".inner-viewport").scrollLeft() / dims.window.w);
										
										if ($ele.children(".inner-viewport").data('curr-month') !== currMonth)	$ele.children(".inner-viewport").data('curr-month', currMonth);
										
										newOffset	=	dims.window.w * ($ele.children(".inner-viewport").data('curr-month') + 1);
										
									} else {
										
										newOffset	=	reserveCalendarWidth * ($ele.children(".inner-viewport").data('curr-month') + 1);
										
									}
									
									$ele
										.children(".inner-viewport")
											.data('curr-month', ($ele.children(".inner-viewport").data('curr-month') + 1))
											.stop(true)
											.animate({
												scrollLeft : newOffset
											}, 500, 'easeInOutCubic');
									
								}
								
							})
						).append(
							$('<div class="inner-viewport" />').data('curr-month', 0)
						).append(
							$('<div class="slider-fade right" />')
						).append(
							$('<div class="slider-fade left" />')
						).append(
							$('<a class="reserve-calendar-close" href="#reset">Close <svg width="32" height="32" viewBox="0 0 24 24" class="ic_close_24px" y="72" style="vertical-align:middle"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></a>').on('click', function (event) {
								
								event.preventDefault();
								
								window.location.hash	=	'#reset';
								
							})
						).append(
							$('<a class="reserve-calendar-next" href="#" title="Click to Choose a Room" />').html("<span>Next Step<span><br />Check Availability</span></span>").on("click", function (event) {
								
								event.preventDefault();
								event.stopPropagation();
								
								//first step, transitioning to second
								//request rooms available or upsells depending on saved vars
								
								//check if the client can connect to SUGAR, if not display warning message
								if (sslNotifyShow) {
									
									//log error
									$.ajax({
										url		:	'/library/php/notify-ssl-issue.php',
										type	:	'post',
										data	:	{
											'page'	:	window.location.href
										},
										success	:	function () {}
									});
									
									window.pepTracking.event('SSL Warning', 'Message Displayed', 'Triggered by header reserve "next step" button');
									
									//show SSL warning message
									$ele.prepend(
										$('<div class="warning-message" style="display:none;" />').append(
											$('<div class="viewport" />').append(
												$('<h3 />').text('Oh No!')
											).append(
												$('<p />').html('Your browser is out-of-date and no longer secure. To protect your information please use a newer browser or call the following phone number to book your reservation: <strong>1-800-217-0049</strong>.')
											).append(
												$('<p />').append(
													$('<a class="generic-btn" href="#" />').text('Continue Anyway').on('click', function (event) {
														
														event.preventDefault();
														
														//track button click
														window.pepTracking.event('SSL Warning', 'Continue Anyway', 'User opted to ignore warning');
														
														//reset SSL Warning flag
														sslNotifyShow	=	false;
														
														//hide SSL Warning
														$ele.find('.warning-message').fadeTo(250, 0, 'easeOutCubic', function () {
															
															//remove SSL Warning from the DOM
															$(this).remove();
															
															//re-trigger click to go to next step
															$ele.find('.reserve-calendar-next').trigger('click');
															
														});
														
													})
												)
											)
										)
									).children('.warning-message').eq(0).fadeIn(250, 'easeOutCubic');
									
								} else {
									
									//collect data from calendars
									var $days		= $ele.find(".calendar-day").filter(".hover"),
										startDate	= {
											d	: $days.eq(0).find(".day-number").text(),
											m	: $days.eq(0).closest(".calendar").data('month'),
											y	: $days.eq(0).closest(".calendar").data('year')
										},
										$activeProp	= $ele.find(".reserve-properties").children(".active"),
										property	= ($activeProp.hasClass('WR1'))
														? { partition: 'WR1', roomCode : 10 }
														: ($activeProp.hasClass('WP1'))
															? { partition: 'WP1', roomCode : 2 }
															: { partition: 'WB1', roomCode : 10 };
									
									if ($days.length < 2) {
										
										showOverlayDialog({
											alertMode		:	true,
											confirmAccept	:	'OK',
											confirmTitle	:	'Select Dates',
											confirmBody		:	'Please select your start and end stay dates.',
											callback		:	'RESERVE-ROOM-CHOOSE-DATES',
											overlayStyle	:	''
										});
										
										return false;
										
									} else if ($activeProp.length === 0) {
										
										showOverlayDialog({
											alertMode				:	true,
											confirmAccept			:	'OK',
											confirmTitle			:	'Select Hotel',
											confirmBody				:	'Please select a hotel for your stay.',
											callback				:	'RESERVE-ROOM-CHOOSE-PROPERTY',
											forceCallback			:	true,
											forceCallbackTimeout	:	5000,
											overlayStyle			:	''
										});

                    $theOverlay.find('.prop')[0].focus();

										return false;
										
									}
									
									if (parseInt(startDate.d, 10) < 10) {
										startDate.d	= '0' + startDate.d;
									}
									
									window.pepTracking.event('Header Reservations', '"Next Step" Clicked');
									
									setTimeout(function () {
										
										window.location	= hotelBookingDomain + '/cgi-bin/lansaweb?PROCFUN+RN+resnet+' + encodeURIComponent(property.partition) + '+funcparms+UP%28A2560%29:;;' + encodeURIComponent(startDate.m) + encodeURIComponent(startDate.d) + encodeURIComponent(parseInt(startDate.y, 10) - 2000) + ';' + encodeURIComponent($days.length - 1) + ';2;;' + encodeURIComponent(property.roomCode) + ';?';
										
									}, 100);
									
								}
								
								return false;
							}).append(
								$('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow_right"></use></svg>')
							)
						).append(
							$('<label class="nights"> </label>').append(
								$('<input type="text" value="0" />').on("change", function () {
									
									//force numeric
									this.value = this.value.replace(/[^0-9]/g, '');
									
									$ele
										.find('.check-out')
											.find('input')
												.data('datepicker')
													.selectDate(
														addDays($ele.find('.check-in').find('input').data('datepicker').selectedDates[0], parseInt(this.value, 10))
													);
									
								})
							).append(
								$('<a title="View Previous Month" class="prev" href="#" />').on("click", function (event) {
									
									event.preventDefault();
									event.stopPropagation();
									
									var $input	= $(this).siblings('input');
									
									$input
										.val(1 * $input.val() - 1)
										.trigger("change");
									
								})
							).append(
								$('<a title="View Next Month" class="next" href="#" />').on("click", function (event) {
									
									event.preventDefault();
									event.stopPropagation();
									
									var $input	= $(this).siblings('input');
									
									$input
										.val(1 * $input.val() + 1)
										.trigger("change");
									
								})
							).append(
								$('<span class="title" />').text("# of Nights")
							)
						).append(
							$('<a class="generic-btn reset-btn small" />').text("Reset Calendars").on("click", function (event) {
								
								event.preventDefault();
								event.stopPropagation();
								
								//clear calendar highlights
								$ele
									.find('.calendar-day')
										.removeClass('hover last-clicked');
								
								//clear the check in input
								$ele
									.find('.check-in')
										.find('input')
											.data('datepicker')
												.clear();
								
								//clearn the check out input
								$ele
									.find('.check-out')
										.find('input')
											.data('datepicker')
												.clear();
								
								//reset datepicker appearances
								$ele
									.find('.check-in, .check-out')
										.find('input')
											.val('- - -');
								
								//reset night count input
								$ele
									.find('.nights')
										.find('input')
											.val('0');
								
							})
						).append(
							$('<a class="generic-btn offer-btn small" />').text("Use Offer Code").on("click", function () {
								window.location	= '/casino/offers/';
								return false;
							})
						);
			

				
			//Disable Online Booking if a maintenance page message has been set
			if ($('html').hasClass('mp-hotel-reservations') && window.location.search.substr(0, 7) !== '?test=1') {
				
				var	$ele	=	$('<div class="reserve-viewport choose-date" />')
									.append('<h2 class="viewport-title">Maintenance Underway</h2>')
									.append('<p style="font-size:2em;color:#000;text-align:center;padding:100px 25px 0 25px">Online reservations are currently undergoing maintenance, to make a reservation please call: <strong>800-217-0049</strong></p>')
									.append('<p style="font-size:1em;color:#000;text-align:center;padding:25px">You can also try refreshing the page to see if the maintenance has completed.</p>');
				
			}
			
			if (propSelect !== '')	$ele.find('.reserve-properties').find("." + propSelect).addClass('active').closest('.reserve-properties').addClass('property-chosen');
			
			$theOverlay.data({ state : 1 }).append($ele);
			
			$theOverlay
				.addClass('active');
			
			$(window).trigger('scroll.global');
			
			if (!$('html').hasClass('mp-hotel-reservations') || window.location.search.substr(0, 7) === '?test=1') {
				
				$.ajax({
					url			: '/library/php/calendar.php',
					type		: 'post',
					data		: {
						t		: 'reserve-form',
						m		: theMonth,
						y		: theYear,
						d		: theData[1],
						s		: theData[3],
						g		: theData[4]
					},
					dataType	: 'json',
					success		: function (response) {
						
						$cal	= $(response.output);
						$days	= $cal.find(".calendar-day");
						
						var	numOfDays	= ($days.filter('.hover').length - 1);
						
						if (numOfDays < 0) {
							numOfDays = 0;
						}
						
						$ele.children(".nights").children("input").val(numOfDays);
						
						$ele.children(".inner-viewport").append(
							$('<div class="room-slider" />').css({
								width	: $cal.length * 345
							}).append($cal)
						);

            focusFirstReservationCalendarDay();

						//need to remove this event handler when changing screens
						var $calendarWrappers	= $ele.find('.calendar-wrapper'),
							$calNext			= $ele.find('.reserve-calendar-next'),
							$checkIn			=	$ele.find('.check-in'),
							$checkOut			=	$ele.find('.check-out');
						
						$cal.find('.calendar-day').on("click", function () {
							if (!$(this).hasClass('disabled')) {
								
								if ($days.filter('.hover').length === 0) {
									
									//first click
									$theOverlay
										.find('.check-in')
											.find('input')
												.data('datepicker')
													.selectDate(findCalendarDate($(this)));
									
								} else if (!$(this).hasClass('hover') || $days.filter('.hover').length > 1) {
									
									if ($days.index(this) > $days.index($days.filter('.hover').eq(0))) {

										//this date is after the start date
										if ($days.filter('.hover').length > 1 && $days.index(this) < $days.index($days.filter('.hover').eq(-1)) && $days.filter('.hover').eq(-1).hasClass('last-clicked')) {
											
											//adjust by the start date
											$theOverlay
												.find('.check-in')
													.find('input')
														.data('datepicker')
															.selectDate(findCalendarDate($(this)));
											
										} else {
											
											//adjust by the end date
											$theOverlay
												.find('.check-out')
													.find('input')
														.data('datepicker')
															.selectDate(findCalendarDate($(this)));
											
										}
										
									} else {
										
										//this date is before the start date
										$theOverlay
											.find('.check-in')
												.find('input')
													.data('datepicker')
														.selectDate(findCalendarDate($(this)));
											
									}

                  $('.reserve-calendar-next')[0].focus();

								}
								
								$days
									.filter(".last-clicked")
										.removeClass("last-clicked");
								
								$(this)
									.addClass("last-clicked");
								
							}
						});
						
					},
					error		: function (a, b, c) {
						if (typeof console === "object" && typeof console.log === "function") {
							console.log(a);
							console.log(b);
							console.log(c);
						}
					}
				});
				
			}
		} else if (theHash === 'opc-login') {
			
			$opcBtn
				.addClass('active');
			
			$opcBtn
				.data('$loginForm')
					.addClass('active')
					.removeClass('hide');
			
			changeOPCButtonText('CLOSE', 'out');
			
			showOverlay();
			
		}
		
	});
	$(function () {
		
		$(window).trigger('hashchange.global');
		
		renderScrollDifference();
		
	});
	
	//HEADER CODE//
	var //$scroller	= $('html, body').add(document),
		//$scroller	= scrollableElement('html', 'body', document, window),
		nav_state	= false,
		nav_offset	= (nav.element.length)
						? nav.element.offset().top
						: 0,
		nav_height	= (nav.element.length)
						? nav.element.height()
						: 0;
	
	if ($("html").hasClass("hashchange")) {
		$(window).on('scroll.header', function () {
			if (responsive.current === 'ui-mobile') {
				nav.element.removeClass("fixed").find("#small-logo").css({ display : 'none', opacity : 0 });
			} else {
				var st	= $(this).scrollTop();
				if (st >= nav_offset && nav_state === false) {
					nav_state	= true;
					nav.element.addClass('fixed').find("#small-logo").css({ display : '' }).stop().fadeTo(750, 1, 'easeInOutCubic');
				} else if (st < nav_offset && nav_state === true) {
					nav_state	= false;
					nav.element.removeClass('fixed').find("#small-logo").stop().fadeTo(750, 0, 'easeInOutCubic', function () { $(this).css({ display : 'none' }); });
				}
			}
		}).trigger('scroll.header');
	}
	
	
	//do all window.resize code
	var resizeTimer		= null,
		iResizeTimer	= null,
		bgLoaded		= false,
		cookieTimer		= null,
		loadFired		= false,
		uiChangetimer	=	null,
		bottomProximity	=	200;	//just needs to default to larger than 165
	
	$(window).on("resize.all load.all orientationchange.all", function (event, delay) {
		if (typeof delay !== 'integer') {
			if (event.type.toLowerCase() === 'load') {
				var delay	= 0;
				loadFired	= true;
			} else {
				var delay	= 100;
			}
		}
		
		function theFunc() {
			//GLOBAL
			//update saved viewport dimensions
			dims.window.w	= $(window).width();
			dims.window.h	= $(window).height();
			
			//determine which responsive-design-break-point should be used
			var found	= false;
			for (var i = 0, l = responsive.points.length; i < l; i++) {
				if (dims.window.w <= responsive.points[i]) {
					found	= true;
					break;
				}
			}
			
			//if no match was found then use largest
			if (!found) {
				i = l;
			}
			
			if (responsive.current !== responsive[i]) {
				
				clearTimeout(cookieTimer);
				cookieTimer	= setTimeout(function () {
					
					document.cookie = "responsive=" + responsive.current + "; path=/;";
					
					$('html')
						.removeClass('ui-transition');
					
				}, 1000);
				
				window.wnresponsive.current	= responsive.current;
				
				$('html')
					.addClass('ui-transition');
			}
			
			$('html').removeClass(responsive.current).addClass(responsive.classes[i]);
			responsive.current	= responsive.classes[i];
			
			clearTimeout(uiChangetimer);
			
			$('html')
				.addClass('ui-transition');
			
			uiChangetimer	=	setTimeout(function () {
				
				$('html')
					.removeClass('ui-transition');
				
			}, 1000);
			
			//NAV
			//set timeout to allow animation to finish before re-aligning navigation
			if (responsive.current !== 'ui-mobile') {
				clearTimeout(iResizeTimer);
				iResizeTimer	= setTimeout(function () {
					
					nav.links.css({ display : '' });
					
					$.each(nav.element.find('.nav-over-wrapper'), function () {
						
						//find the horizontal position of the link
						var $that	= $(this).next(),
							w		= $that.width(),
							left	= $that.offset().left + (w / 2) - 63;//,
							//left	= (parseInt($(window).width()) / 2) - (parseInt($(this).css('width')) / 2),
							$this	= $(this),
							width	= (responsive.current === 'ui-widescreen')	? (($this.find(".nav-over-page").length * 188) + 36)	: (($this.find(".nav-over-page").length * 140) + 20);
						
						$this.width(width);
						
						var old_left	= left;
						
						//only make these calculations for non-mobile output
						if (i > 0) {
							//make sure to not clip on the right side
							if ((left + width + 15) > dims.window.w) {
								left	= dims.window.w - width - 15;
							}
							
							//make sure to not clip on the left side
							if (left < 10) {
								left	= 10;
							}
						
							//update pointer
							var $tri			= $(this).children(".tri"),
								tri_old_left	= (1 * $tri[0].style.left) || 0,
								tri_new_left	= tri_old_left + 85 + (old_left - left);
							$tri[0].style.left	= tri_new_left + 'px';
							
							
							this.style.left	= left + 'px';
						}
						
						$.data($that[0], 'state', 'leave');
						
					});
					
				}, 150);
			}
			
			$('html')
				.addClass('loaded');
			
			dims.document.h	=	$(document).height();
			
			calculateBottomProximity();
			
		}
		clearTimeout(resizeTimer);
		if (delay === 0) {
			theFunc();
		} else {
			resizeTimer = setTimeout(theFunc, delay);
		}
	}).trigger("resize.all", 0);
	
	//VTour links
	$("#body").find(".vtour-link").on("click", function () {
		var $this	= $(this),
			src		= $this.attr("href");
		
		if ($this.data("state") === "show") {
			$("#body").prepend('<div class="vtour-frame"><iframe class="slideshow-replacement" src="' + src + '"></iframe></div>').find(".slideshow.sub-show").fadeOut(500, function () {
				$("#body").css('padding-top', 465);
			});
			$this.data("state", "hide").text("Hide VTour");
			
			window.pepTracking.event('VTour', 'Open', window.location.pathname, 0, false);
		} else {
			$("#body").css('padding-top',  40).find('.vtour-frame').fadeOut(750, 'easeInOutCubic', function () {
				$(this).remove();
			}).end().find(".slideshow.sub-show").fadeIn(750, 'easeInOutCubic');
			$this.data("state", "show").text("Show VTour");
			
			window.pepTracking.event('VTour', 'Close', window.location.pathname, 0, false);
		}
		
		return false;
	}).end()
	//Text Size Code
	.find(".text-size-btn").on("click", function () {
		if (!$("html").hasClass("text-increase")) {
			//go big
			$("html").addClass("text-increase");
			
			document.cookie = "text-size=text-increase; path=/;";
			
			window.pepTracking.event('Text Size', 'Increase', window.location.pathname, 0, false);
		} else {
			//go normal
			$("html").removeClass("text-increase");
			
			document.cookie = "text-size=; path=/;";
			
			window.pepTracking.event('Text Size', 'Normal', window.location.pathname, 0, false);
		}
		return false;
	});
	
	
	
	
	//setup GA tracking code
  window.pepTracking	= {
    page: function (customPage) {
      if (typeof gtag === 'undefined') return;

      if (typeof customPage === 'string' && customPage !== '') {
        gtag('event', 'page_view', {
          page: customPage
        });
      }
    },
    event: function (category, action, extra, value, ni) {

      if (typeof gtag === 'undefined') return;

      if (typeof category !== 'string') category = 'N/A';

      if (typeof action !== 'string') action = 'N/A';

      if (typeof extra !== 'string') extra = 'N/A';

      if (typeof value !== 'number') value = 0;

      if (typeof ni !== 'boolean') ni = false;

      gtag('event', action, {
        hitType: 'event',
        event_category: category,
        event_action: action,
        event_label: extra,
        nonInteraction: ni,
        transport: 'beacon',
        value: value
      });

    },
    getGALinkerParam: function () {
      //get GA4 tracker param
      const formNode = document.createElement('FORM');
      formNode.action = 'https://booking.wendoverfun.com/';
      formNode.style.opacity = '0';
      formNode.addEventListener('submit', (event) => {event.preventDefault();});

      const buttonNode = document.createElement('BUTTON');
      buttonNode.type = 'submit';
      formNode.append(buttonNode);

      document.body.append(formNode);

      buttonNode.click();

      const _glNode = formNode.querySelector('input[name="_gl"]');
      if (_glNode) {
        return _glNode.value;
      }

      return '';
    }
  };
	$("#body").find('.track-click').on("click", function () {
		window.pepTracking.page($(this).attr('href'));
	});
	
	//check for lists and the need for scrolling headers
	//var $headers	= $("#body").find(".reg-list").find(".header");
	//if ($headers.length) {
		var $headers			= [],
			headerTops			= [],
			headerHeights		= [],
			listHeights			= [],
			navOffset			= 33,
			headerResizeTimer	= null,
			headersLastRender	= -1;
		
		$(window).on("resize.list-headers load.list-headers", function () {
			if ($headers.length) {
				var delay	= 250;
				if (responsive.current === 'ui-mobile') {
					delay	= 500;
				}
				clearTimeout(headerResizeTimer);
				headerResizeTimer	= setTimeout(function () {
					headerTops	= [];
					listHeights	= [];
					for (var i = 0, l = $headers.length; i < l; i++) {
						headerHeights.push($headers.eq(i).closest("ul").children().eq(0).height());
						headerTops.push($headers.eq(i).closest("ul").children().eq(0).offset().top);
						listHeights.push($headers.eq(i).closest("ul").height());
					}
				}, delay);
			}
		});
		
		$(function () {
			$(window).trigger("resize.list-headers");
		});
		
		function renderHeaders() {
			
			if (currentScroll !== headersLastRender) {
			
				headersLastRender	= currentScroll;
			
				var flag	= false;
				if ($headers.length) {
					flag	= true;
				}
				$headers	= $("#body").find(".reg-list").find(".header");
				if ($headers.length) {
					if (flag === false) {
						$(window).trigger("resize.list-headers");
					}
					var	defaultTop			= -6,
						touchViewport		= (responsive.current === "ui-mobile")
												? true
												: false,
						localNavOffset		= navOffset;
					
					if (touchViewport) {
						localNavOffset		= 0;
						//localExtraOffset	= [0, 0, 0];
					}
					
					for (var i = 0, l = $headers.length; i < l; i++) {
						if ((currentScroll + localNavOffset) > headerTops[i] && (currentScroll + localNavOffset) < (headerTops[i] + listHeights[i] - defaultTop)) {
							$headers.eq(i).css({
								top	: currentScroll + localNavOffset - headerTops[i] - headerHeights[i] + defaultTop
							});
						} else if ((currentScroll + localNavOffset) < headerTops[i] && (currentScroll + localNavOffset)) {
							$headers.eq(i).css({
								top	: ''
							});
						}
					}
				}
			}
		}
		
		(function headerLoop(){
		  requestAnimationFrame(headerLoop);
		  renderHeaders();
		})();
	//}
	
	
	
	
	//Check if the user can connect to SUGAR
	var sslNotifyCookie	=	document.cookie.replace(/(?:(?:^|.*;\s*)ssl-notify\s*\=\s*([^;]*).*$)|^.*$/, "$1") || '{"ok":"no","time":0}',
		sslNotifyObj	=	$.parseJSON(sslNotifyCookie),
		sslNotifyShow	=	false,
		sslNotifyFunc	=	function () {
			
			$.ajax({
				url				:	'https://reserve1.peppermillcas.com:4323/misc/check-secure-connection.js',
				dataType		:	'jsonp',
				jsonpCallback	:	'cscCallback',
				timeout			:	15000,
				success			:	function () {
					
					//only check once an hour if a connection was successfully made
					sslNotifyShow	=	false;
					document.cookie	=	'ssl-notify={"ok":"yes","time":' + new Date().getTime() + '}; path=/;';
					
				},
				error		:	function (a, b, c) {
					
					sslNotifyShow	=	true;
					document.cookie	=	'ssl-notify={"ok":"no","time":' + new Date().getTime() + '}; path=/;';
					
				}
			});
			
		};
	
	//backwards compatability
	if (typeof sslNotifyObj === 'number') {
		
		sslNotifyObj	=	{
			ok		:	'no',
			time	:	sslNotifyObj
		};
		
	}
	
	if (sslNotifyObj.time === 0) {
		
		//object was just initialized, no check has occured
		sslNotifyFunc();
		
	} else if (sslNotifyObj.ok === 'yes' && sslNotifyObj.time < (new Date().getTime() - 3600000)) {
		
		//object was created from cookie but the last check was over an hour ago
		sslNotifyFunc();
		
	} else if (sslNotifyObj.ok === 'no') {
		
		sslNotifyShow	=	true;
		
		if (sslNotifyObj.time < (new Date().getTime() - 100000)) {
			
			//object was created from cookie and the last check failed but it was checked over five minutes ago
			sslNotifyFunc();
			
		}
	}
	
	
	
	
	if (typeof String.prototype.trimLeft !== "function") {
		String.prototype.trimLeft = function() {
			return this.replace(/^\s+/, "");
		};
	}
	if (typeof String.prototype.trimRight !== "function") {
		String.prototype.trimRight = function() {
			return this.replace(/\s+$/, "");
		};
	}
	if (typeof Array.prototype.map !== "function") {
		Array.prototype.map = function(callback, thisArg) {
			for (var i=0, n=this.length, a=[]; i<n; i++) {
				if (i in this) a[i] = callback.call(thisArg, this[i]);
			}
			return a;
		};
	}
	function getCookies() {
		var c = document.cookie, v = 0, cookies = {};
		if (document.cookie.match(/^\s*\$Version=(?:"1"|1);\s*(.*)/)) {
			c = RegExp.$1;
			v = 1;
		}
		if (v === 0) {
			c.split(/[,;]/).map(function(cookie) {
				var parts = cookie.split(/=/, 2),
					name = decodeURIComponent(parts[0].trimLeft()),
					value = parts.length > 1 ? decodeURIComponent(parts[1].trimRight()) : null;
				cookies[name] = value;
			});
		} else {
			c.match(/(?:^|\s+)([!#$%&'*+\-.0-9A-Z^`a-z|~]+)=([!#$%&'*+\-.0-9A-Z^`a-z|~]*|"(?:[\x20-\x7E\x80\xFF]|\\[\x00-\x7F])*")(?=\s*[,;]|$)/g).map(function($0, $1) {
				var name = $0,
					value = $1.charAt(0) === '"'
							  ? $1.substr(1, -1).replace(/\\(.)/g, "$1")
							  : $1;
				cookies[name] = value;
			});
		}
		return cookies;
	}
	
	function getCookie(name) {
		return getCookies()[name];
	}
	
	
	
	
	//check if the OPC auto-login cookie is set and the user isn't already logged-in
	if (!$header.find('.opc-btn').hasClass('logged-in')) {
		
		var opc_cookie	=	getCookie('OPC_RM');
		
		if (typeof opc_cookie === 'string') {
			
			$.ajax({
				url			:	'/library/php/passport/login.php',
				type		:	'post',
				dataType	:	'json',
				cache		:	false,
				data		:	{
					REMEMBER_ME_TOKEN	:	opc_cookie
				},
				success		:	function (response) {
					
					if (typeof response === 'string') {
						
						response	=	$.parseJSON(response);
						
					}
					
					if (response.status === 'success') {
						
						$header.find('.opc-btn').html('<span>Now Logged-In<span class="msg">View Your Rewards</span></span>').addClass('logged-in auto-login');
						
						//track auto-login
						window.pepTracking.event('Players Club', 'Auto Login', window.location.pathname, 0, false);
						
					}
					
				},
				timeout		: 20000,
				error		: function (a, b, c) {
					
					if (typeof console === 'object' && typeof console.log !== 'undefined') {

						console.log(a);
						console.log(b);
						console.log(c);
						
					}
					
				}
			});
			
		}
		
	}
	
	
	
	
	
	
	
	
	
	//DIALOG CODE
	window.showLoader	=	function () {
		
		$('html')
			.addClass('show-overlay show-loading-spinner');
		
	};
	
	window.showOverlay	=	function () {
		
		$('html')
			.addClass('show-overlay');

    focusFirstReservationCalendarDay();
	};

  function focusFirstReservationCalendarDay() {
    let $dayToFocus = $theOverlay.find('.calendar-day.last-clicked').first();
    if (!$dayToFocus.length) {
      $dayToFocus = $theOverlay.find('.calendar-day:not(.disabled) .cell-wrapper').first();
    }

    if ($dayToFocus.length) {
      $dayToFocus[0].focus();
    }
  }

	window.hideLoader	=	function () {
		
		$('html')
			.removeClass('show-overlay show-loading-spinner clear-overlay');
		
		$('.dialog')
			.trigger('close', [true]);
		
	};
	
	var ajaxLinkCallbacks	=	{};
	
	window.ajaxLinkegisterCallback	=	function (action, callback) {

		if (typeof action !== 'string' || action.length === 0)	return false;
		if (typeof callback !== 'function')						return false;
		
		ajaxLinkCallbacks[action]	=	callback;
		
		return true;
		
	};
	
	$(document)
		.on('click', function (event) {
			
			var clickIsOnDatepicker	=	/(^|\s){1}datepicker\-\-.{1,10}($|\s)/.test(event.target.className);
			
			if (!clickIsOnDatepicker) {
				
				hideLoader();
				
				$('.dialog')
					.trigger('close', [true]);
				
				if ($theOverlay.hasClass('active') || $opcBtn.data('$loginForm').hasClass('active')) {
					
					window.location.hash	=	'reset';
					
				}
				
			}
			
		})
		.on('keydown', function (event) {
			
			if (event.which === 27) {
				
				$('.dialog').trigger('click');
				
				if ($theOverlay.hasClass('active') || $opcBtn.data('$loginForm').hasClass('active'))	window.location.hash	=	'reset';
				
			}
			
		});
	
	function sendOverlayDialogAjax(linkData, linkEle) {
		
		showLoader();
		
		if (typeof linkEle !== 'object')	var linkEle	=	null;
		
		$.ajax({
			url			:	'/library/api/ajax-links.php?' + linkData.query,
			type		:	'post',
			dataType	:	'json',
			data		:	(typeof linkData.dataOBJ === 'object')
								?	linkData.dataOBJ
								:	{},
			success		:	function (response) {
				
				if (response.STATUS === 'SUCCESS') {
					
					pepNotify.show(60000, response.MSG);
					
				} else {
					
					pepNotify.show(60000, response.MSG, 'error_outline', 'ERROR');
					
				}
				
				$('html')
					.removeClass('show-overlay clear-overlay show-loading-spinner');
				
				if (typeof linkEle === 'object')	$(linkEle).data('lock', false);
				
			},
			error		:	function (jqXHR, errorString, errorTypeString) {
				
				pepNotify.show(60000, errorString, 'error_outline', 'ERROR');
				
				$('html')
					.removeClass('show-overlay clear-overlay show-loading-spinner');
				
				if (typeof linkEle === 'object')	$(linkEle).data('lock', false);
				
			}
		});
		
	}
	
	function runOverlayDialogCallback(linkData, linkEle) {
		
		if (typeof linkEle !== 'object')	var linkEle	=	null;
		
		var dataARR	=	[];
		
		if (typeof linkData.dataOBJ === 'object') {
			
			for (var key in linkData.dataOBJ) {
				
				dataARR.push(linkData.dataOBJ[key]);
				
			}
			
		}
		
		//run callback if it exists
		if (linkData.callback in ajaxLinkCallbacks) {
			
			if (typeof linkEle !== 'undefined') {
				
				ajaxLinkCallbacks[linkData.callback].apply(linkEle, dataARR);
				
			} else {
				
				ajaxLinkCallbacks[linkData.callback].apply(window, dataARR);
				
			}
			
		}
		
	}
	
	window.showOverlayDialog	=	function (linkData, linkEle) {
		
		if (typeof linkEle !== 'object')	var linkEle	=	null;
		
		var defaults	=	{
				alertMode				:	false,
				confirmAccept			:	'OK',
				confirmDeny				:	'CANCEL',
				confirmTitle			:	'',
				confirmBody				:	'',
				callback				:	'',
				query					:	'',
				forceCallback			:	false,
				forceCallbackTimeout	:	10000,
				forceCallbackTimer		:	null,
				overlayStyle			:	''	//'clear'
			},
			options		=	$.extend({}, defaults, linkData);
		
		if (options.overlayStyle.length)	options.overlayStyle	=	' ' + options.overlayStyle.replace(/[^a-z0-9\-_]/gi, '') + '-overlay';
		
		$('html')
			.addClass('show-overlay' + options.overlayStyle);
		
		if (options.confirmBody.length) {
			
			//show confirmation for action
			var $confirm	=	$('<div class="dialog confirm opening" tabindex="0"></div>'),
				$actions	=	$('<div class="actions"></div>');
			
			if (options.confirmTitle.length)	$confirm.append('<h3>' + options.confirmTitle + '</h3>');
			if (!options.alertMode)				$actions.append('<a class="deny" href="#" tabindex="0">' + options.confirmDeny + '</a>');
			
			$confirm
				.append('<p>' + options.confirmBody + '</p>')
				.append(
					$actions
						.append('<a class="accept" href="#" tabindex="0">' + options.confirmAccept + '</a><div class="clearme"></div>')
				);
			
			$confirm
				.data({
					lastFocusedElement	:	document.activeElement
				})
				.on('close', function (event, unlockLink) {
					
					if (typeof unlockLink !== 'boolean')	var unlockLink	=	false;
					
					if ($confirm.hasClass('opening'))	return;
					
					$confirm
						.onCSSTransitionEnd(function () {
							
							$confirm
								.remove();
							
						})
						.removeClass('active');
					
					clearTimeout(options.forceCallbackTimer);
					
					if (unlockLink && typeof linkEle === 'object')					$(linkEle).data('lock', false);
					if (typeof $confirm.data('lastFocusedElement') === 'object')	$confirm.data('lastFocusedElement').focus();
					
				})
				.on('click', function (event) {
					
					event.stopPropagation();
					
				})
				.find('.deny')
					.on('click', function (event) {
						
						event.preventDefault();
						
						$confirm
							.trigger('close', [true]);
						
						$('html')
							.removeClass('show-overlay clear-overlay');
						
					})
				.end()
				.find('.accept')
					.on('click', function (event) {
						
						event.preventDefault();
						
						//find any extra data that needs to be sent
						var dataOBJ		=	{},
							sendData	=	false;
						
						$confirm
							.find('input')
								.each(function () {
									
									sendData			=	true;
									dataOBJ[this.name]	=	this.value;
									
								});
						
						if (sendData) {
							
							options.dataOBJ		=	dataOBJ;
							linkData.dataOBJ	=	dataOBJ;
							
						}
						
						$confirm
							.trigger('close');
						
						if (options.alertMode) {
							
							hideLoader();
							
						} else {
							
							$('html')
								.addClass('show-loading-spinner')
								.removeClass('clear-overlay');
						}
						
						clearTimeout(options.forceCallbackTimer);
						
						if (options.callback.length)	runOverlayDialogCallback(linkData, linkEle);
						if (options.query.length)		sendOverlayDialogAjax(options, linkEle);

					});
			
			$('body')
				.append($confirm);
			
			//initialize pepvalidate-v3 form(s) if necessary
			if ($confirm.find('.pepvalidate-v3')) {
				
				$.each($confirm.find('.pepvalidate-v3'), pepvalidateInitForm);
				
				$confirm
					.find('input, textarea')
						.on('keydown', function (event) {
							
							if (event.which === 13) {
								
								event.preventDefault();
								$confirm.find('.actions').find('.accept').trigger('click');
								
							}
							
						});
				
			}
			
			setTimeout(function () {
				
				$confirm
					.css({
						marginLeft	:	$confirm.outerWidth() / -2,
						marginTop	:	$confirm.outerHeight() / -2
					})
					.addClass('active')
					.focus();
				
				if (options.forceCallback && options.callback.length) {
					
					//force the callback after the specified amount of time
					options.forceCallbackTimer	=	setTimeout(function () {
						
						runOverlayDialogCallback(linkData, linkEle);
						
					}, options.forceCallbackTimeout);
					
				}
				
				setTimeout(function () {
					
					$confirm
						.removeClass('opening');
					
				}, 500);
				
			}, 50);
			
		} else {
			
			$('html')
				.addClass('show-loading-spinner');

			if (options.callback.length)	runOverlayDialogCallback(options, linkEle);
			if (options.query.length)		sendOverlayDialogAjax(options, linkEle);
			
		}
		
	}
	
	$(document)
		.on('click', 'a.ajax-link', function (event) {
			
			var $link	=	$(this);
			
			if (typeof $link.data('query') !== 'string' && typeof $link.data('callback') !== 'string')	return;
			
			if ($link.data('lock'))	return false;
			
			showOverlay();
			
			$link.data('lock', true);
			
			event.preventDefault();
			
			showOverlayDialog($link.data(), this);
			
		})
		.on('click', 'a', function (event) {
			
			var whiteList	=	[
				'wendoverfun.com/',
				'booking.wendoverfun.com/',
				'devbooking.wendoverfun.com/',
				'dev.wendoverfun.com/',
				'reserve1.peppermillcas.com/',
				'peppermilllasvegas.com/',
				'peppermillreno.com/',
				'westernvillagesparks.com/',
				'wvsparks.com/'
			];
			
			//make sure this is for an external link
			if (this.href === '' || this.href.substr(0, 1) === '/' || this.href.substr(0, 11) === 'javascript:')	return;
			
			for (var i = 0, l = whiteList.length; i < l; i++) {
				
				var reg	=	new RegExp('^http[s]{0,1}:\/\/[w]{0,3}\.{0,1}' + whiteList[i], 'i');
				
				if (reg.test(this.href))	return;
				
			}
			
			//now we're dealing with links that don't go to our website and need to be confirmed
			event.preventDefault();
			event.stopPropagation();
			
			showOverlayDialog({
				confirmAccept			:	'CONTINUE',
				confirmTitle			:	'You are now exiting wendoverfun.com',
				confirmBody				:	'The Peppermill Resorts are not responsible for the content of external sites.',
				callback				:	'EXTERNAL-WEBSITE-WARNING',
				forceCallback			:	true,
				forceCallbackTimeout	:	10000
			}, this);
			
		});
	
	$(function () {
		
		ajaxLinkegisterCallback(
			'EXTERNAL-WEBSITE-WARNING',
			function () {
				
				$('html')
					.removeClass('show-overlay clear-overlay');
				
				var win	=	window.open(this.href, '_blank');
				
				if (typeof win === 'undefined' || !win) {
					
					window.location	=	this.href;
					
				} else {
					
					win.focus();
					
				}
				
			}
		);
		
	});
	
	
	
	
	
	
	
	
	
	/*HEADER OPC LOGIN*/
	var $opcBtn	=	nav.element.find('.opc-btn');

	$opcBtn
		.data({
			timer		:	null,
			clickOK		:	true,
			$loginForm	:	$('#opc-login'),
			textInit	:	$opcBtn.children('span').html()
		})

		.on('click', function (event) {
			
			event.preventDefault();
			if (event.target.tagName.toUpperCase() === 'A') {
				window.location	=	event.target.href;
				return;
			} else if ($opcBtn.hasClass('logged-in')) {
				if ($opcBtn.filter('[data-offer-count]').length && event.offsetX > $opcBtn.outerWidth() - 48) {
					window.location	=	'/casino/players-club/offers/';
				} else {
					window.location	=	'/casino/players-club/home/';
				}

				return;
			}

			if (!$opcBtn.data('clickOK'))	return;
			
			if ($opcBtn.hasClass('active'))	window.location.hash	=	'reset';
			else							window.location.hash	=	'opc-login';
			
			$opcBtn
				.data({
					timer	:	setTimeout(function () {
						
						$opcBtn
							.data('clickOK', true);
						
					}, 500),
					clickOK	:	false
				});
			
		});
	
	
	$opcBtn
		.data('$loginForm')
			.on('click', function (event) {
				
				event.stopPropagation();
				
			})
			.find('.close')
				.on('click', function (event) {
					
					event.preventDefault();
					
					window.location.hash	=	'reset';
					
				});
	
	$(function () {
		
		pepvalidateRegisterCallback(
			'GENERAL-SUCCESS',
			function (msg) {
				this.classList.remove('loading');
				this.classList.add('hide');
				pepNotify.show(10000, msg);
			}
		);

		pepvalidateRegisterCallback(
			'HEADER-OPC-LOGIN-SUCCESS',
			function (redirect) {
				
				//`this` is the form
				window.pepTracking.event("Players Club", "Login", window.location.pathname, 0, false);
				
				setTimeout(function () {
					
					window.location	=	redirect;
					
				}, 100);
				
			}
		);
		
		ajaxLinkegisterCallback(
			'HEADER-OPC-LOGIN-ERROR-CLOSE',
			function () {

				if (!$('#opc-login').hasClass('active')) {
					
					hideLoader();
					
				} else {
					
					showOverlay();
					
				}
			}
		);
		
		pepvalidateRegisterCallback(
			'HEADER-OPC-LOGIN-ERROR',
			function (msg) {
				
				$(this)
					.removeClass('loading');
				
				//`this` is the form
				showOverlayDialog({
					alertMode		:	true,
					confirmAccept	: 	'OK',
					confirmTitle	:	'',
					confirmBody		:	msg,
					callback		:	'HEADER-OPC-LOGIN-ERROR-CLOSE'
				});
				
			}
		);
		
		pepvalidateInitForm.call($('#opc-login-form')[0]);
		
	});
	
	/*$('#opc-login-form')
		.on("submit", function (event) {
			
			event.preventDefault();
			
			if ($(this).find('input[type=submit]').hasClass("inactive"))	return;
			
			//validation
			var $form	=	$(this),
				$u		= $form.find("[name=username]").removeClass("error"),
				$p		= $form.find("[name=password]").removeClass("error"),
				er		= false;
			
			if ($.trim($u.val()) === "") {
				$u.addClass("error");
				er	=	true;
			}
			if ($.trim($p.val()) === "") {
				$p.addClass("error");
				er	=	true;
			}
			if (er) {
				
				showOverlayDialog({
					alertMode: true,
					confirmAccept: 'OK',
					confirmTitle: 'All Fields Required',
					confirmBody: 'Please enter a usernme and password.'
				});
				
			} else {
				
				$form.find('input[type=submit]').addClass("loading inactive");
				
				var data	= { mDktaDF : $u.val(), lDfpwDF : $p.val() };
				
				if ($form.find("[name=remember_me]").is(":checked")) {
					data.oWwcnmket	= 1;
				}
				
				$.ajax({
					url			: "/library/php/passport/login.php",
					type		: "post",
					dataType	: "json",
					data		: data,
					success		: function (response) {
						
						if (response.status === "success") {
							
							window.pepTracking.event("Players Club", "Login", window.location.pathname, 0, false);
							
							setTimeout(function () {
								
								window.location	= response.msg;
								
							}, 150);
							
						} else {
							
							showOverlayDialog({
								alertMode: true,
								confirmAccept: 'OK',
								confirmTitle: '',
								confirmBody: response.msg
							});
							
							$form.find('input[type=submit]').removeClass("loading inactive");
							
						}
						
					},
					error		: function (a, b, c) {
						
						if (typeof console === "object" && typeof console.log === "function") {
							console.log(a, b, c);
						}
						
						$form.find('input[type=submit]').removeClass("loading inactive");
						
						showOverlayDialog({
							alertMode: true,
							confirmAccept: 'OK',
							confirmTitle: 'We Apologize',
							confirmBody: 'An error occured, please try again later.'
						});
						
					}
					
				});
				
			}
			
		});*/
	
	
	
	
	
	
	
	
	
	//SETUP NOTIFICATIONS
	window.pepNotify	=	{
		ele			:	$('#notifications'),
		viewport	:	$('#notifications').children('.viewport'),
		show		:	function (duration, msg, type, actionText, actionLink, callback, forceClose) {
			
			if (typeof forceClose !== 'boolean')	var forceClose	=	false;
			
			//make sure this notification doesn't already exist
			var $match	=	pepNotify.viewport.children('.notification').filter(function () {
					
					var data	=	$(this).data();
					
					return (data.duration === duration && data.msg === msg && data.type === type && data.actionText === actionText && data.actionLink === actionLink);
					
				});
			
			if ($match.length) {
				
				if ($match.find('.count').length === 0) {
					
					$match.append('<span class="count">2</span>');
					
					setTimeout(function () {
						
						$match
							.find('.count')
								.onCSSAnimationEnd(function () {
									
									$(this).removeClass('bounce');
									
								})
								.addClass('show bounce');
						
					}, 50);
					
				} else {
					
					$match
						.find('.count')
							.text(parseInt($match.find('.count').text(), 10) + 1)
							.onCSSAnimationEnd(function () {
								
								$(this).removeClass('bounce');
								
							}).addClass('bounce');
					
				}
				
				pepNotify.reset($match);
				
				return;
				
			}
			
			var $ele	=	$(pepNotify.buildHTML(msg, type, actionText, actionLink, callback))
								.data({
									duration		:	duration,
									msg				:	msg,
									type			:	type,
									actionText		:	actionText,
									actionLink		:	actionLink,
									callback		:	callback,
									forceClose		:	forceClose
								});
			
			$ele
				.on('mouseenter', function () {
					
					if ($ele.hasClass('closing')) return;
					
					if (!$ele.data('forceClose'))	clearTimeout($ele.data('timer'));
					
					$ele.addClass('hover');
					
				})
				.on('mouseleave', function () {
					
					pepNotify.activate($ele);
					
					$ele.removeClass('hover');
					
				})
				.find('.action')
					.on('click', function (event) {
						
						if ($(this).hasClass('close') || $(this).attr('href') === '#')	event.preventDefault();
						
						$ele.removeClass('hover').addClass('closing');
						
						pepNotify.close($ele, true);
						
					});
			
			pepNotify.viewport.append($ele);
			
			if (pepNotify.viewport.children('.notification').filter('.active').length === 0) {
				
				setTimeout(function () {
					
					pepNotify.activate($ele);
					
				}, 50);
				
			}
			
		},
		close		:	function ($ele, closeFromClick) {
			
			if (typeof closeFromClick !== 'boolean')	var closeFromClick	=	false;
			
			pepNotify.ele.onCSSTransitionEnd(function () {
				
				if (!$ele.data('forceClose') && $ele.hasClass('hover') && !$ele.hasClass('closing'))	return;
				
				if (typeof $ele.data('callback') === 'function' && (closeFromClick || $ele.data('forceClose')))	{
					
					$ele.data('callback')();
					
				}
				
				$ele.remove();
				
				pepNotify.rotate();
				
			}).removeClass('show');
			
			$('html').removeClass('show-notify');
			
		},
		reset		:	function ($ele) {
			
			clearTimeout($ele.data('timer'));
			
			$ele.data('timer', setTimeout(function () {
				
				pepNotify.close($ele);
				
			}, $ele.data('duration')));
			
		},
		activate	:	function ($ele) {
			
			if ($ele.hasClass('closing'))	return;
			
			pepNotify.ele.addClass('show');
			
			$('html').addClass('show-notify');
			
			$ele.addClass('active').data('timer', setTimeout(function () {
				
				pepNotify.close($ele);
				
			}, $ele.data('duration')));
			
		},
		rotate		:	function () {
			
			var $notifications	=	pepNotify.viewport.children('.notification');
			
			if ($notifications.length > 0 && $notifications.filter('.active').length === 0) {
				
				pepNotify.activate($notifications.eq(0));
				
			}
			
		},
		buildHTML	:	function (msg, type, actionText, actionLink, actionCallback) {
			
			var html	=	'<div class="notification" role="status"><table class="no-zebra"><tbody><tr><td class="content">';
			
			if (typeof type === 'string')	html	+=	'<span class="material-icons">' + type + '</span> ';
			
			html	+=	msg + '</td><td class="action-cell">';
			
			if (typeof actionText === 'string' && (typeof actionLink === 'string' || typeof actionCallback === 'function'))	{
				
				if (typeof actionLink !== 'string')	var actionLink	=	'#';
				
				html	+=	'<a class="action" href="' + actionLink + '">' + actionText + '</span>';
				
			} else {
				
				html	+=	'<a class="action close" href="#">HIDE</span>';
				
			}
			
			html	+=	'</td></tr></table></div>';
			
			return html;
			
		}
	};
	
	
	
	
	
	
	
	//HANDLE PASSPORT NOTIFICATIONS
	$('#body')
		.children('.call-to-action')
			.find('.passport-notifications')
				.on('click', function (event) {
					
					event.preventDefault();
					event.stopPropagation();
					
					var $notificationBtn	=	$(this);
					
					$.ajax({
						url			:	'/library/api/passport-notifications.php',
						type		:	'post',
						dataType	:	'json',
						data		:	{
							ACTION			:	'UPDATE_NOTIFICATION_VIEW_COUNT',
							NOTIFICATION_ID	:	$notificationBtn.data('notifications')[0].id
						},
						error		:	function (a, b, c) {
							
							$.ajax({
								url			:	'/library/php/capture-js-error.php',
								type		:	'post',
								dataType	:	'json',
								data		:	{
									je_message	:	b,
									je_source	:	'main-V3.js',
									je_lineno	:	0,
									je_colno	:	0,
									je_url		:	window.location.href,
									je_stack	:	''
								}
							});
							
						}
					});
					
					ajaxLinkegisterCallback(
						'PASSPORT-NOTIFICATION-HIDE',
						function () {
							
							$.ajax({
								url			:	'/library/api/passport-notifications.php',
								type		:	'post',
								dataType	:	'json',
								data		:	{
									ACTION				:	'UPDATE_NOTIFICATION_STATUS',
									NOTIFICATION_ID		:	$notificationBtn.data('notifications')[0].id,
									NOTIFICATION_STATUS	:	'STOP'
								},
								success		:	function (response) {
									
									if (response.STATUS === 'SUCCESS') {
										
										$notificationBtn
											.remove();
										
										pepNotify.show(30000, 'You will no longer see this notification.');
										
									} else {
										
										pepNotify.show(30000, 'An error occured, please try again later.');
										
									}
									
								},
								error		:	function (a, b, c) {
									
									pepNotify.show(30000, 'An error occured, please try again later.');
									
									$.ajax({
										url			:	'/library/php/capture-js-error.php',
										type		:	'post',
										dataType	:	'json',
										data		:	{
											je_message	:	b,
											je_source	:	'main-V3.js',
											je_lineno	:	0,
											je_colno	:	0,
											je_url		:	window.location.href,
											je_stack	:	''
										}
									});
									
								},
								complete	:	function () {
									
									hideLoader();
									
								}
							});
							
						}
					);
					
					showOverlayDialog({
						confirmAccept	:	'STOP SHOWING',
						confirmDeny		:	'OK',
						confirmTitle	:	$notificationBtn.data('notifications')[0].title,
						confirmBody		:	$notificationBtn.data('notifications')[0].body,
						callback		:	'PASSPORT-NOTIFICATION-HIDE'
					});
					
				});
	
})(jQuery);
